// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:13:50.115Z
// Property: Woodland Oaks (ID: 6737460151192627)
// Collections: 28 amenities, 6 floorplans (live), 36 photos, 73 POIs, 4 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151192627",
  "property_external_id": "4707262",
  "property_zillow_url": "https://www.zillow.com/b/woodland-oaks-apartments-conway-ar-5Xhx69/",
  "property_apartments_url": "https://www.apartments.com/woodland-oaks-conway-ar/32ns1ef",
  "property_google_business_url": "https://www.google.com/maps/place/Woodland+Oaks/data=!4m2!3m1!1s0x0:0xf8c27d3e56eddfed?sa=X&ved=2ahUKEwjElLOexrySAxXpmGoFHS16H2YQ_BJ6BAgNEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "17321136789",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "woodland-oaks",
  "property_name": "Woodland Oaks",
  "property_website_url": "https://www.woodlandoaksapthome.com/",
  "property_domain": "https://www.woodlandoaksapthome.com/",
  "property_address": "1620 Middle Rd",
  "property_full_address": "1620 Middle Rd, Conway, AR 72032",
  "property_address_1": "1620 Middle Rd",
  "property_address_2": null,
  "property_address_city": "Conway",
  "property_address_state": "AR",
  "property_address_zip_full": "72032-8961",
  "property_address_zip": "72032",
  "property_address_country": "US",
  "property_address_county": "Faulkner County",
  "property_neighborhood_address": "Downtown Conway",
  "property_address_latitude": "35.0780242",
  "property_address_longitude": "-92.4051253",
  "property_email": "woodlandoaks@rreafresidential.com",
  "property_phone": "(501) 548-6268",
  "property_call_tracking_phone": "501-530-8873",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Woodland Oaks in Conway, AR, spacious two and three-bedroom apartments await, complete with modern amenities. Dive into relaxation at the pool, energize in the fitness center, or unwind at the clubhouse. With a pet washing station and serene picnic areas, your perfect home is just a tour away!",
  "property_long_description": "Welcome to Woodland Oaks, your premier apartment community in beautiful Conway, AR! Offering spacious and thoughtfully designed two and three-bedroom floor plans, Woodland Oaks caters to your lifestyle needs with stylish comfort and modern conveniences.\n\nExperience resort-style living with an array of exceptional amenities right at your doorstep. Take a refreshing dip in our sparkling pool, unwind at the spa, or stay active in our fully equipped fitness center. Enjoy the convenience of furnished units available for a hassle-free move and take advantage of our controlled access, ensuring your safety and peace of mind.\n\nOur community is designed for relaxation and socializing, featuring a welcoming clubhouse, cozy lounge, and inviting picnic area with grills for outdoor dining. For those who love the outdoors, our sun-kissed sundeck and serene courtyard provide the perfect setting to soak up the Arkansas sunshine. Plus, your furry friends will appreciate our dedicated pet washing station!\n\nWoodland Oaks also boasts practical features including an elevator, Wi-Fi throughout the property, bicycle storage, and on-site retail options for added convenience. With our gated community, you’ll enjoy both privacy and a true sense of belonging.\n\nFind your new home today at Woodland Oaks! Browse our availability or schedule a tour to visit our community and experience the perfect blend of comfort, luxury, and convenience that awaits you in Conway, AR. Don’t miss out on making Woodland Oaks your forever home!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e8491-d3be-726f-a6e8-c61694ca333c.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with blue lounge chairs and a picnic table, with a building in the background.",
    "public_id": "019e8491-d3be-726f-a6e8-c61694ca333c",
    "storage_key": "property/6737460151192627/019e8491-d3be-726f-a6e8-c61694ca333c.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "168",
  "property_year_built": "2004",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "99.40476190476191",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": "3",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "null",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://woodlandoaks.activebuilding.com/login",
  "property_apply_now_url": "https://8444224.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e8491-dcc1-7329-aff2-1b36a90d87c5.webp",
  "property_primary_logo_media": {
    "alt_text": "Woodland Oaks Apartments logo with a stylized leaf inside a circle above the property name.",
    "public_id": "019e8491-dcc1-7329-aff2-1b36a90d87c5",
    "storage_key": "property/6737460151192627/019e8491-dcc1-7329-aff2-1b36a90d87c5.webp",
    "width": 1250,
    "height": 428
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e8491-dcc1-7329-aff2-1b36a90d87c5.webp",
  "property_secondary_logo_media": {
    "alt_text": "Woodland Oaks Apartments logo with a stylized leaf inside a circle above the property name.",
    "public_id": "019e8491-dcc1-7329-aff2-1b36a90d87c5",
    "storage_key": "property/6737460151192627/019e8491-dcc1-7329-aff2-1b36a90d87c5.webp",
    "width": 1250,
    "height": 428
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e8e87-1d51-74ff-8c61-32c9496d11d5.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019e8e87-1d51-74ff-8c61-32c9496d11d5",
    "storage_key": "property/6737460151192627/019e8e87-1d51-74ff-8c61-32c9496d11d5.webp",
    "width": 1250,
    "height": 428
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e8e87-1115-7548-a981-696c648cb5be.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019e8e87-1115-7548-a981-696c648cb5be",
    "storage_key": "property/6737460151192627/019e8e87-1115-7548-a981-696c648cb5be.webp",
    "width": 1250,
    "height": 428
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#0d345e",
  "property_secondary_color": "#eae9e1",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": " - ",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": " - ",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "900 - 1200",
  "property_sqft_min": "900",
  "property_sqft_max": "1200",
  "property_price_range": "950 - 1250",
  "property_price_min": "950",
  "property_price_max": "1250",
  "property_available_units": 1,
  "property_facebook_url": "https://www.facebook.com/people/Woodland-Oaks-Apartments/61554629973253/",
  "property_instagram_url": "https://www.instagram.com/woodlandoaks_rrliving/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJyUEMIL-D0ocR7d_tVj59wvg",
  "property_youtube_url": "https://www.youtube.com/watch?t=811&v=MeIe4xEZjC8",
  "property_yelp_url": "https://www.yelp.com/biz/woodland-oaks-apartments-conway-2",
  "property_tiktok_url": "https://www.tiktok.com/@woodlandoaksapthomes",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Woodland Oaks",
  "property_home_romance_title": "Find Your Perfect Haven for Love and Connection",
  "property_home_amenities_blurb": "<p>Discover the <a href=\"/gallery/\">picture-perfect lifestyle</a> you've always wanted here at Woodland Oaks Apartments. An irresistible combination of convenience and recreational activities are awaiting you in Conway, AR. Beyond the beauty of each apartment home is a recreation-rich setting to entice outdoor enthusiasts. All just minutes away from Interstate 40, Highway 64, and Arkansas 286, there are plenty of dining, entertainment, and shopping places nearby.</p>",
  "property_home_floorplans_blurb": "<p>Located downtown, many different restaurants and fun adventures are nearby for your enjoyment! Our <a href=\"/floor-plans/\">Woodland Oaks apartments</a> are your gateway to fun and excitement with family and friends in Conway, AR. You're just minutes away from shopping at different malls and marketplaces where you can find everything you need. Have fun experiences exploring the parks and trails in the surrounding area or enjoy a good movie with others.</p>",
  "property_home_gallery_blurb": "At Woodland Oaks in Conway, AR, choose from spacious two and three-bedroom floor plans designed for comfort and style. Unwind in our inviting clubhouse, splash in the pool, or enjoy a game in the gameroom. Picture yourself living here, surrounded by laughter, relaxation, and the perfect amenities.",
  "property_home_neighborhood_blurb": "Nestled in the heart of Conway, AR, Woodland Oaks offers spacious two and three-bedroom apartments surrounded by vibrant local charm. Embrace a lifestyle enriched by nearby parks, cafes, and shops. Check out the neighborhood offerings and uncover your new favorite spots just around the corner from your next home sweet home!",
  "property_home_reviews_blurb": "At Woodland Oaks in Conway, AR, community and care come together seamlessly. Residents rave about our \"clean and well-maintained\" environment, where friendly staff go the extra mile to create memorable experiences. With family and pet-friendly amenities, discover why so many call Woodland Oaks home. Join a community that feels like family!",
  "property_neighborhood_blurb": "<p>Located downtown, many different restaurants and fun adventures are nearby for your enjoyment! Our <a href=\"/floor-plans/\">Woodland Oaks apartments</a> are your gateway to fun and excitement with family and friends in Conway, AR. You're just minutes away from shopping at different malls and marketplaces where you can find everything you need. Have fun experiences exploring the parks and trails in the surrounding area or enjoy a good movie with others.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Enjoy all the luxuries our <a href=\"/neighborhood/\">Conway, Arkansas</a>, community offers, such as a business center, clubhouse, and fitness center. There's something for everyone, including your furry friend so bring them along. Enjoy the game room, playground, or lounge and soak up the vitamin D in our saltwater swimming pool. What sets us apart is the community's true spirit, and on-site professional management.</p>",
  "property_applynow_blurb": "At Woodland Oaks in Conway, AR, find your perfect two or three-bedroom retreat surrounded by luxurious amenities. Dive into the refreshing pool, unwind at the spa, or enjoy gatherings at the picnic area. With furnished units and controlled access, your ideal lifestyle awaits. Lease online today and elevate your living experience!",
  "property_contactus_blurb": "At Woodland Oaks in Conway, AR, find your ideal home among our spacious two and three-bedroom floor plans. Designed for comfort and convenience, each layout invites you to experience a vibrant lifestyle surrounded by nature. Have questions? Our leasing team is ready to help you discover your new home today!",
  "property_faqs_blurb": "At Woodland Oaks in Conway, AR, find your perfect fit with spacious two and three-bedroom floor plans tailored for modern living. Curious about our community? Browse our FAQs page for insights that help you make an informed decision—your ideal home awaits!",
  "property_floorplans_blurb": "<p>Tailored to those who prefer a carefree lifestyle but demand the privacy and distinction of a home, Woodland Oaks offers two and three-bedroom apartment homes for rent. <a href=\"/amenities/\">Enjoy apartment elegance</a> in an exclusive setting with two expansive floor plans. Discover your inner chef with full-size kitchen appliances and a large kitchen pantry. You'll be able to entertain your family and friends in style with elegant crown molding, ceiling fans, hardwood floors, and natural lighting.</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our <a href=\"/amenities/\">community</a> and <a href=\"/floor-plans/\">apartments</a>.</p>",
  "property_interactivemap_blurb": "At Woodland Oaks in Conway, AR, your perfect apartment awaits! Choose from stylish two and three-bedroom floor plans, complemented by top-notch amenities like a refreshing pool, modern fitness center, and relaxing spa. Dive into comfort—use our interactive community map to find your ideal home today!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "At Woodland Oaks in Conway, AR, we believe that great friends make great neighbors. Our spacious two and three-bedroom floor plans offer the perfect backdrop for unforgettable moments. Share the joy of living in a vibrant community—refer a friend today and let them experience the charm of Woodland Oaks!",
  "property_residentaccess_blurb": "At Woodland Oaks in Conway, AR, our spacious two and three-bedroom floor plans offer the perfect blend of comfort and convenience. Enhance your living experience by easily managing your home through our resident portal, where paying rent and scheduling maintenance is just a click away!",
  "property_reviews_blurb": "At Woodland Oaks in Conway, AR, residents rave about the sense of community and exceptional service. One resident excitedly shares, “We loved living here! The management staff were always super nice and maintenance very helpful!” Experience a welcoming atmosphere where you and your family can truly feel at home.",
  "property_created_at": "1752257253420",
  "property_scheduletour_blurb": "At Woodland Oaks in Conway, AR, our thoughtfully designed two and three-bedroom floor plans cater to your lifestyle needs. Picture yourself thriving in a vibrant community where comfort meets convenience. Curious about life here? Our residents’ stories reveal the true essence of Woodland Oaks—schedule a tour today!",
  "property_thankyou_blurb": "Thank you for reaching out! At Woodland Oaks in Conway, AR, our spacious two and three-bedroom floor plans are designed to elevate your living experience. Get ready to enjoy a unique blend of comfort and convenience. Expect a friendly team member to connect with you soon to discuss your future home!",
  "property_virtualtours_blurb": "<p>At Woodland Oaks Apartments, we make finding your new home quick & easy with our beautiful virtual tour. Explore 360-degree views of your new apartment home & the exceptional amenities that accompany it.</p>",
  "property_copyright": "2025 All Rights Reserved. Woodland Oaks",
  "property_seo_title_home": "Woodland Oaks | Apartments in Conway, AR",
  "property_seo_description_home": "Welcome to Woodland Oaks in Conway, AR, where modern living meets unparalleled comfort. Choose from spacious two and three-bedroom floor plans, each designed with your lifestyle in mind. Enjoy top-notch amenities including a sparkling pool, fully-equipped fitness center, and inviting clubhouse—all nestled within a gated community. Our pet-friendly environment features essential conveniences like on-site retail, a pet washing station, and bike storage, making every day as easy as it is enjoyable. With Wi-Fi, controlled access, and serene outdoor spaces, you'll find your perfect oasis here. Find your new home today and elevate your living experience at Woodland Oaks!",
  "property_seo_title_floorplans": "Floor Plans | 2 - 3 Apartments in Conway, AR",
  "property_seo_description_floorplans": "Unveil the charm of Woodland Oaks in Conway, AR! Our thoughtfully designed two and three-bedroom floor plans cater to your lifestyle, providing the perfect blend of comfort and modern living. Browse our available apartment homes now and uncover the ideal space that feels like home.",
  "property_seo_title_amenities": "Amenities | Conway, AR Apartments for Rent",
  "property_seo_description_amenities": "Experience the charm of Woodland Oaks in Conway, AR, where modern comforts meet a vibrant lifestyle. From relaxing by the pool and energizing in our fitness center to unwinding in the clubhouse or hosting a barbecue in the picnic area, our community is designed for you. Choose from spacious two- and three-bedroom floor plans, enjoy pet-friendly amenities, and indulge in luxurious features like a spa and sundeck. Elevate your living experience with us—your perfect sanctuary awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Conway, AR",
  "property_seo_description_gallery": "Immerse yourself in the vibrant life at Woodland Oaks in Conway, AR. Our photo gallery showcases stunning two- and three-bedroom floor plans, complemented by a host of luxurious amenities, including a refreshing pool, state-of-the-art fitness center, and inviting clubhouse. Picture relaxing on the sundeck or enjoying a weekend BBQ in the picnic area. With controlled access, pet-friendly spaces, and convenient on-site retail, your ideal lifestyle awaits. Take a look and envision your new home—where comfort meets style!",
  "property_seo_title_virtualtours": "Virtual Tours | Woodland Oaks Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Woodland Oaks in Conway, AR, where comfort meets style in our spacious two and three-bedroom apartments. Dive into our virtual tour and envision your new home, complete with modern amenities and a vibrant community. Don't miss the opportunity to see what makes Woodland Oaks the perfect place for you to thrive!",
  "property_seo_title_interactivemap": "Interactive Map | Woodland Oaks Apartments",
  "property_seo_description_interactivemap": "Step into the inviting lifestyle of Woodland Oaks in Conway, AR, where modern amenities meet tranquil living. Choose from spacious two and three-bedroom floor plans, and enjoy exclusive access to a refreshing pool, fully-equipped fitness center, and a relaxing spa. With pet-friendly options and on-site retail for ultimate convenience, your new home is more than just an apartment—it’s a vibrant community. Ready to find your perfect fit? Use our interactive community map to browse available apartments, view pricing, and claim your space today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Conway, AR",
  "property_seo_description_neighborhood": "Experience the charm of Woodland Oaks in Conway, AR! Nestled in a vibrant neighborhood, our community offers spacious two and three-bedroom floor plans alongside a wealth of local attractions. Uncover hidden gems, trendy hotspots, and family-friendly activities just steps away from your doorstep. Dive into the local culture and see how our surroundings make Woodland Oaks the perfect place to call home!",
  "property_seo_title_contact": "Contact Us | Woodland Oaks",
  "property_seo_description_contact": "Experience the charm of Woodland Oaks in Conway, AR, where spacious two and three-bedroom floor plans cater to your lifestyle. Whether you're looking for a cozy retreat or a family-friendly space, we have the perfect home waiting for you. Have questions? Reach out to our leasing team today and let's turn your dream living experience into a reality!",
  "property_seo_title_faqs": "FAQs | Apartments in Conway, AR",
  "property_seo_description_faqs": "Nestled in the heart of Conway, AR, Woodland Oaks redefines modern living with spacious two and three-bedroom apartments tailored for your lifestyle. Dive into upscale amenities like our refreshing pool, state-of-the-art fitness center, and inviting clubhouse. With pet-friendly features, exclusive on-site retail, and serene outdoor spaces, every corner is designed for comfort and convenience. Got questions? Our FAQs page is your go-to for insights on making Woodland Oaks your next home sweet home!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Conway, AR",
  "property_seo_description_reviews": "Experience the vibrant lifestyle at Woodland Oaks in Conway, AR, where comfort meets convenience. With spacious two and three-bedroom floor plans and a wealth of amenities—including a refreshing pool, state-of-the-art fitness center, and a relaxing spa—every day feels like a getaway. Our community is perfectly designed for modern living, featuring controlled access, on-site retail, and pet-friendly spaces like a washing station and picnic area. Don’t just take our word for it; see what our residents say about their Woodland Oaks experience!",
  "property_seo_title_applynow": "Apply Now | Apartments in Conway, AR",
  "property_seo_description_applynow": "Experience the vibrant lifestyle at Woodland Oaks in Conway, AR, where comfort meets convenience in our spacious two and three-bedroom apartments. Enjoy resort-style amenities including a refreshing pool, state-of-the-art fitness center, and a clubhouse perfect for social gatherings. With furnished units and on-site retail, your everyday needs are right at your doorstep. Embrace outdoor living with our sun-soaked sundeck, picnic area, and serene courtyard. Ideal for pet lovers and active lifestyles, discover the perfect blend of relaxation and community. Apply online today and find your new home!",
  "property_seo_title_residentaccess": "Resident Access | Woodland Oaks",
  "property_seo_description_residentaccess": "\"Welcome to Woodland Oaks in Conway, AR—your gateway to convenient living. Access the resident portal to effortlessly pay rent, schedule maintenance, and enhance your apartment experience today!\"",
  "property_seo_title_referafriend": "Refer A Friend | Woodland Oaks",
  "property_seo_description_referafriend": "Refer a friend to Woodland Oaks in Conway, AR, where great friends make the best neighbors! Share the vibrant lifestyle and welcoming community that awaits. Your referrals could lead to new adventures and lasting connections. Join us in spreading the word today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Woodland Oaks",
  "property_seo_description_scheduletour": "\"Step into serenity at Woodland Oaks in Conway, AR. Experience vibrant living with beautiful landscapes and modern amenities. Schedule a tour today and find your perfect home amidst nature’s embrace!\"",
  "property_seo_title_privacy": "Privacy Policy | Woodland Oaks",
  "property_seo_description_privacy": "At Woodland Oaks in Conway, AR, your trust is our priority. Our Privacy Policy outlines how we protect your personal information while you enjoy a seamless living experience. Ensure your peace of mind—view our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Woodland Oaks",
  "property_seo_description_accessibility": "\"At Woodland Oaks in Conway, AR, we prioritize digital inclusivity for all residents. Our Accessibility Statement reflects our commitment to ensuring a welcoming online experience. Join our community where everyone can thrive—together, we make living accessible!\"",
  "property_seo_title_sitemap": "Sitemap | Woodland Oaks",
  "property_seo_description_sitemap": "\"Navigate your way through Woodland Oaks in Conway, AR! Our sitemap makes it easy to uncover every corner of our vibrant apartment community, from spacious floor plans to delightful amenities. Start your journey today!\"",
  "property_seo_title_thankyou": "Thank You | Woodland Oaks",
  "property_seo_description_thankyou": "Thank you for reaching out to Woodland Oaks in Conway, AR! Your journey toward a perfect home starts here. A friendly member of our team will soon connect with you to answer all your questions and guide you toward your new, tranquil lifestyle.",
  "property_seo_title_pets": "Pet Policy | Apartments in Conway, AR",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293616989",
  "amenities": [
    {
      "id": "ec_14b3af161697c78bd69b7e79",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "generator",
      "external_id": "false",
      "title": "24‑Hour Courtesy Patrol",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5d3271d98e41b872a7250ac0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "generator",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0026575ec0d77937518291f0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "generator",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_30a2d24b0fe5ec4c7a9a20ad",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "generator",
      "external_id": "false",
      "title": "Easy Access to Freeways and Shopping",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_69b2666909c39e4c46e7bda9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "generator",
      "external_id": "false",
      "title": "Game Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ab4187b56fb01f2e1f691059",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "generator",
      "external_id": "false",
      "title": "Gated Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_505ff0aa86bffacea2b8df41",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "generator",
      "external_id": "false",
      "title": "Guest Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a3c8c5ac4339f41191f31725",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "generator",
      "external_id": "false",
      "title": "High‑speed Internet Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ad08f6d493463f02f610377c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "generator",
      "external_id": "false",
      "title": "On‑call Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9e2e612641861758ef641fa7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "generator",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_de501f53050905feae69afdb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "generator",
      "external_id": "false",
      "title": "Professional Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_baad878ec87a6e264bbda01d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "generator",
      "external_id": "false",
      "title": "Resident Events",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_be62792f0b24550be43b3c65",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "generator",
      "external_id": "false",
      "title": "Shimmering Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a4a48ca23aa7ed2d0451fb1f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "generator",
      "external_id": "false",
      "title": "Short‑term Leasing Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8413aebf4477961e530f0c37",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "generator",
      "external_id": "false",
      "title": "State‑of‑the‑art Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_625efe9922c5c627d3ea6d50",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "generator",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cc23870ad8bf24e628ab4721",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "generator",
      "external_id": "false",
      "title": "Central Air and Heating",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_494590b4fd695075c521e744",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "generator",
      "external_id": "false",
      "title": "Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_23d49ed262fd15a8f3718264",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "generator",
      "external_id": "false",
      "title": "Elegant Crown Molding",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c84082f096b730a692b27b59",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "generator",
      "external_id": "false",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fd76c13107feee6534f768d9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "generator",
      "external_id": "false",
      "title": "Full‑size Kitchen Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_80210ac3cc795f5543728cf6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "generator",
      "external_id": "false",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_df14334291bf97df79629732",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "generator",
      "external_id": "false",
      "title": "Natural Lighting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_69c338d709478f24aa328f2e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "generator",
      "external_id": "false",
      "title": "Pantry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_282695c972bea849fc242048",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "generator",
      "external_id": "false",
      "title": "Spacious Bathroom",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bbe48bd977da66f6c591393e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "generator",
      "external_id": "false",
      "title": "Spacious Floor Plans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cca0a23e3f0815fa91a9f92b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "generator",
      "external_id": "false",
      "title": "Washer and Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_07cc57f5e702a794d28f8fe4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "generator",
      "external_id": "false",
      "title": "Washer and Dryer in Home",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_b91dee16-599a-4ced-a9c4-bc4de7f9b269",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e8491-d3be-726f-a6e8-c61694ca333c.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with blue lounge chairs and a picnic table, with a building in the background.",
        "public_id": "019e8491-d3be-726f-a6e8-c61694ca333c",
        "storage_key": "property/6737460151192627/019e8491-d3be-726f-a6e8-c61694ca333c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool, surrounded by comfortable lounge chairs and picnic tables for a perfect day in the sun.",
      "link": "",
      "alt_text": "Outdoor swimming pool with blue lounge chairs and a picnic table, with a building in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c79f43b7-142a-4fb5-b20c-50c2c875e61a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/01a0f902-92ff-73f7-9255-72676b3c9212.webp",
      "image_media": {
        "alt_text": "Cozy library with two accent chairs, a plush ottoman, and a large bookshelf filled with books.",
        "public_id": "01a0f902-92ff-73f7-9255-72676b3c9212",
        "storage_key": "property/6737460151192627/01a0f902-92ff-73f7-9255-72676b3c9212.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Relax and unwind in our community library, a quiet space to read, work, or simply enjoy a moment of peace.",
      "link": "",
      "alt_text": "Cozy library with two accent chairs, a plush ottoman, and a large bookshelf filled with books.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4f82c2e8-0f7e-414e-aa94-0a79356a95da",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/01a0f902-97ae-71a7-b409-a72e3d62da0c.webp",
      "image_media": {
        "alt_text": "Cozy living room with a sectional sofa, coffee table, and TV.",
        "public_id": "01a0f902-97ae-71a7-b409-a72e3d62da0c",
        "storage_key": "property/6737460151192627/01a0f902-97ae-71a7-b409-a72e3d62da0c.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Relax in this inviting living room featuring a comfortable sectional sofa, a stylish coffee table, and a modern entertainment center. Perfect for unwinding or entertaining guests.",
      "link": "",
      "alt_text": "Cozy living room with a sectional sofa, coffee table, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_46665c54-56ce-4fa8-9ac4-a10fcf2bf13a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/01a0f902-92b6-749c-b75a-b4c844f2f6c3.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstand, closet, and view into bathroom",
        "public_id": "01a0f902-92b6-749c-b75a-b4c844f2f6c3",
        "storage_key": "property/6737460151192627/01a0f902-92b6-749c-b75a-b4c844f2f6c3.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Inviting bedroom with plush bedding, a spacious closet, and an ensuite bathroom, perfect for relaxation.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, nightstand, closet, and view into bathroom",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_348602ae-0988-4d70-9a40-3fab717cbaa5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/01a0f903-3a4a-71d9-a3c3-e775e3ccaf15.webp",
      "image_media": {
        "alt_text": "Kitchen sink with dark cabinets and a pass-through to the living area.",
        "public_id": "01a0f903-3a4a-71d9-a3c3-e775e3ccaf15",
        "storage_key": "property/6737460151192627/01a0f903-3a4a-71d9-a3c3-e775e3ccaf15.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring a double basin sink, dark cabinetry, and a pass-through window offering a glimpse into the dining and living spaces.",
      "link": "",
      "alt_text": "Kitchen sink with dark cabinets and a pass-through to the living area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_115db1a6-215a-4146-8a28-706591543b6a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/01a0f902-977a-764e-9af1-ee61cc59c24e.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a large bed, dresser, and a view of the outside through the window.",
        "public_id": "01a0f902-977a-764e-9af1-ee61cc59c24e",
        "storage_key": "property/6737460151192627/01a0f902-977a-764e-9af1-ee61cc59c24e.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Relax in this beautifully appointed bedroom, featuring a plush queen-size bed, ample storage, and natural light streaming through the window.",
      "link": "",
      "alt_text": "Cozy bedroom with a large bed, dresser, and a view of the outside through the window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_89914ee3-93cf-4a07-945b-785cd5b06eeb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/01a0f902-9187-7158-a893-fa177b7c91ff.webp",
      "image_media": {
        "alt_text": "Modern bathroom with bathtub, toilet, and vanity.",
        "public_id": "01a0f902-9187-7158-a893-fa177b7c91ff",
        "storage_key": "property/6737460151192627/01a0f902-9187-7158-a893-fa177b7c91ff.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious and clean apartment bathroom featuring a white bathtub with a shower curtain, a modern toilet, and a vanity with a granite countertop. Decorated with plants and artwork for a relaxing ambiance.",
      "link": "",
      "alt_text": "Modern bathroom with bathtub, toilet, and vanity.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f9cb1418-b980-4663-9a52-1e4eb6fb3108",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/01a0f902-93cc-76b8-9ac9-1f9d25373be5.webp",
      "image_media": {
        "alt_text": "Modern living room with comfortable seating, dining area, and wall-mounted TV.",
        "public_id": "01a0f902-93cc-76b8-9ac9-1f9d25373be5",
        "storage_key": "property/6737460151192627/01a0f902-93cc-76b8-9ac9-1f9d25373be5.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Relax and entertain in this stylish living space featuring plush seating, a dedicated dining area, and a large wall-mounted TV, perfect for unwinding after a long day.",
      "link": "",
      "alt_text": "Modern living room with comfortable seating, dining area, and wall-mounted TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ce02d1d4-8b36-4723-b942-71f185f21b80",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/01a0f902-9c79-70ee-bfcb-f45dee3e2186.webp",
      "image_media": {
        "alt_text": "Communal lounge area with tables, chairs, and TVs.",
        "public_id": "01a0f902-9c79-70ee-bfcb-f45dee3e2186",
        "storage_key": "property/6737460151192627/01a0f902-9c79-70ee-bfcb-f45dee3e2186.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Relax and socialize in our beautifully appointed communal lounge, featuring comfortable seating and entertainment options.",
      "link": "",
      "alt_text": "Communal lounge area with tables, chairs, and TVs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d9c3020b-ed9a-412f-8fce-ce834cce8988",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/01a0f902-92b0-704e-8efa-c13f6714b99e.webp",
      "image_media": {
        "alt_text": "Business center with computers, chairs, and seating area.",
        "public_id": "01a0f902-92b0-704e-8efa-c13f6714b99e",
        "storage_key": "property/6737460151192627/01a0f902-92b0-704e-8efa-c13f6714b99e.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Stay connected and productive in our convenient business center, featuring computers and comfortable seating.",
      "link": "",
      "alt_text": "Business center with computers, chairs, and seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6067605c-0b52-44a9-af91-8c3faadb3bed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e8491-b709-757c-8ac5-71741c5bd1de.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and picnic tables.",
        "public_id": "019e8491-b709-757c-8ac5-71741c5bd1de",
        "storage_key": "property/6737460151192627/019e8491-b709-757c-8ac5-71741c5bd1de.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, perfect for relaxing on sunny days. Lounge chairs and picnic tables are available for your convenience.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and picnic tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b4dff636-41d7-4396-8f17-c1ea5d6ebeb1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e8491-fd48-7268-ad34-86067a0f099b.webp",
      "image_media": {
        "alt_text": "Kitchen with dark cabinets, black appliances, and granite countertops.",
        "public_id": "019e8491-fd48-7268-ad34-86067a0f099b",
        "storage_key": "property/6737460151192627/019e8491-fd48-7268-ad34-86067a0f099b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring dark wood cabinetry, black appliances including a stove and dishwasher, and granite-style countertops with a double sink. The gray wood-look flooring complements the space.",
      "link": "",
      "alt_text": "Kitchen with dark cabinets, black appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_60f37acd-8d3e-4ef3-b010-4f6fb099f086",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e8491-e3ff-7669-84ba-d7238c509cbb.webp",
      "image_media": {
        "alt_text": "Stylish lounge area with a leather sofa, armchair, coffee table, and abstract art on the walls.",
        "public_id": "019e8491-e3ff-7669-84ba-d7238c509cbb",
        "storage_key": "property/6737460151192627/019e8491-e3ff-7669-84ba-d7238c509cbb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and socialize in our modern lounge area, featuring comfortable seating, tasteful decor, and a convenient pass-through to the kitchen.",
      "link": "",
      "alt_text": "Stylish lounge area with a leather sofa, armchair, coffee table, and abstract art on the walls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0851e610-3db2-45bf-af94-9e6dff61444b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e8491-de01-741f-ad10-1b3dca81a585.webp",
      "image_media": {
        "alt_text": "Fitness studio with exercise equipment and yoga mats.",
        "public_id": "019e8491-de01-741f-ad10-1b3dca81a585",
        "storage_key": "property/6737460151192627/019e8491-de01-741f-ad10-1b3dca81a585.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness studio, complete with cardio machines and a dedicated yoga space featuring colorful mats.",
      "link": "",
      "alt_text": "Fitness studio with exercise equipment and yoga mats.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e84676af-0062-4bb8-b1c3-ee5fb6da9233",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e8491-e555-7115-9e63-ef3500c185e1.webp",
      "image_media": {
        "alt_text": "Treadmill, elliptical, weight rack, and multi-station gym equipment in a community fitness center.",
        "public_id": "019e8491-e555-7115-9e63-ef3500c185e1",
        "storage_key": "property/6737460151192627/019e8491-e555-7115-9e63-ef3500c185e1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active and energized in our fully-equipped fitness center, featuring treadmills, ellipticals, weight machines, and free weights.",
      "link": "",
      "alt_text": "Treadmill, elliptical, weight rack, and multi-station gym equipment in a community fitness center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f4495ccc-9196-4dd9-a7e9-87f37b6215fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e8491-df4f-713f-a707-d3f48ffa6fbd.webp",
      "image_media": {
        "alt_text": "Communal lounge area with tables and chairs.",
        "public_id": "019e8491-df4f-713f-a707-d3f48ffa6fbd",
        "storage_key": "property/6737460151192627/019e8491-df4f-713f-a707-d3f48ffa6fbd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Gather in our comfortable communal lounge, perfect for socializing or working remotely. Equipped with tables and chairs, it's a versatile space for residents.",
      "link": "",
      "alt_text": "Communal lounge area with tables and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9a1a9bbd-d235-4113-a0fa-e416af910154",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e8491-b719-767c-95ec-e5b41abca77c.webp",
      "image_media": {
        "alt_text": "An enclosed dog park with agility equipment and a covered area.",
        "public_id": "019e8491-b719-767c-95ec-e5b41abca77c",
        "storage_key": "property/6737460151192627/019e8491-b719-767c-95ec-e5b41abca77c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, featuring agility equipment for your furry friends and a shaded area for relaxation.",
      "link": "",
      "alt_text": "An enclosed dog park with agility equipment and a covered area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8a5197f2-cee7-40e9-a36c-b628aeb03b67",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e8491-e16c-753f-b560-8caea819e66a.webp",
      "image_media": {
        "alt_text": "Playground with slides and climbing structures in front of apartment buildings.",
        "public_id": "019e8491-e16c-753f-b560-8caea819e66a",
        "storage_key": "property/6737460151192627/019e8491-e16c-753f-b560-8caea819e66a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at the community playground, featuring colorful slides and climbing structures, perfect for children's recreation.",
      "link": "",
      "alt_text": "Playground with slides and climbing structures in front of apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0096cf43-5db1-47ff-8ad9-489d48c5ea1a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e8492-3eed-7480-957f-e84bbe78ab73.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with white siding and black stairs.",
        "public_id": "019e8492-3eed-7480-957f-e84bbe78ab73",
        "storage_key": "property/6737460151192627/019e8492-3eed-7480-957f-e84bbe78ab73.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "View of the exterior of the apartment building, featuring white siding, black railings, and an outdoor staircase leading to the second floor.",
      "link": "",
      "alt_text": "Exterior of apartment building with white siding and black stairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_861a3a58-ba76-492f-aff8-8aad00783713",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e8492-0df4-73fb-9727-6f955799a51d.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with dark cabinets and wood-look flooring",
        "public_id": "019e8492-0df4-73fb-9727-6f955799a51d",
        "storage_key": "property/6737460151192627/019e8492-0df4-73fb-9727-6f955799a51d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area flows into the kitchen, featuring dark cabinetry and modern wood-look flooring.",
      "link": "",
      "alt_text": "Living room and kitchen area with dark cabinets and wood-look flooring",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_928b57a3-21d9-4452-9497-888093c7e3af",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e8491-fd37-760b-af1c-a6a50f0c7bd0.webp",
      "image_media": {
        "alt_text": "Spacious living room with wood-look flooring, ceiling fan, and pass-through to kitchen.",
        "public_id": "019e8491-fd37-760b-af1c-a6a50f0c7bd0",
        "storage_key": "property/6737460151192627/019e8491-fd37-760b-af1c-a6a50f0c7bd0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy the open-concept living space with beautiful wood-look floors and a convenient pass-through window to the kitchen. Perfect for entertaining and comfortable everyday living.",
      "link": "",
      "alt_text": "Spacious living room with wood-look flooring, ceiling fan, and pass-through to kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0f9005a0-962d-49ca-a92a-0413c560e2e8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e8491-fbaa-71c8-9fed-82a3a8a67b39.webp",
      "image_media": {
        "alt_text": "Bedroom with plush carpet and ceiling fan, doorway to hallway",
        "public_id": "019e8491-fbaa-71c8-9fed-82a3a8a67b39",
        "storage_key": "property/6737460151192627/019e8491-fbaa-71c8-9fed-82a3a8a67b39.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring soft carpeting and a ceiling fan. The room offers access to a hallway, creating a comfortable and functional living space.",
      "link": "",
      "alt_text": "Bedroom with plush carpet and ceiling fan, doorway to hallway",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_826a2909-f641-4c7b-901f-765bfad7a374",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e8491-f7d6-7638-af0c-98c9948f7c5e.webp",
      "image_media": {
        "alt_text": "Bedroom with closet and view into a bathroom",
        "public_id": "019e8491-f7d6-7638-af0c-98c9948f7c5e",
        "storage_key": "property/6737460151192627/019e8491-f7d6-7638-af0c-98c9948f7c5e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring plush carpeting, a ceiling fan, ample closet space, and a private ensuite bathroom with a vanity and toilet.",
      "link": "",
      "alt_text": "Bedroom with closet and view into a bathroom",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c140deeb-7294-49ef-aaae-cec1911427c6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e8491-f231-71d8-b71d-30ed2b60cd6f.webp",
      "image_media": {
        "alt_text": "Bedroom with ceiling fan and large closet doors.",
        "public_id": "019e8491-f231-71d8-b71d-30ed2b60cd6f",
        "storage_key": "property/6737460151192627/019e8491-f231-71d8-b71d-30ed2b60cd6f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring plush carpeting, a ceiling fan, and ample storage with large closet doors. The room offers a comfortable and inviting atmosphere.",
      "link": "",
      "alt_text": "Bedroom with ceiling fan and large closet doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fae1a7e1-875f-4d1a-8c5b-5c6adc6e9978",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e8491-f866-76dc-aefd-b0f05f107a46.webp",
      "image_media": {
        "alt_text": "Bathroom with a bathtub, toilet, and vanity.",
        "public_id": "019e8491-f866-76dc-aefd-b0f05f107a46",
        "storage_key": "property/6737460151192627/019e8491-f866-76dc-aefd-b0f05f107a46.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a white bathtub and shower, a modern vanity with a granite countertop, and a toilet. The space is well-lit and has a contemporary feel with wood-look flooring.",
      "link": "",
      "alt_text": "Bathroom with a bathtub, toilet, and vanity.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5c512686-7e02-4fc5-a72f-01f079ea65a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e8491-dbfc-74f2-badf-8035b4efb156.webp",
      "image_media": {
        "alt_text": "Exterior view of a two-story apartment building with white siding and a black staircase.",
        "public_id": "019e8491-dbfc-74f2-badf-8035b4efb156",
        "storage_key": "property/6737460151192627/019e8491-dbfc-74f2-badf-8035b4efb156.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Beautifully maintained community with a classic exterior. Enjoy comfortable living in this apartment building, featuring easy access to all units.",
      "link": "",
      "alt_text": "Exterior view of a two-story apartment building with white siding and a black staircase.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1d129f10-e492-462a-8d00-648e742bf404",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e8491-ecc6-76af-b425-9955d40c9b05.webp",
      "image_media": {
        "alt_text": "Leasing office reception desk with chairs in waiting area.",
        "public_id": "019e8491-ecc6-76af-b425-9955d40c9b05",
        "storage_key": "property/6737460151192627/019e8491-ecc6-76af-b425-9955d40c9b05.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our leasing office, where our friendly team is ready to assist you.",
      "link": "",
      "alt_text": "Leasing office reception desk with chairs in waiting area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_911b4698-4650-4807-bb27-2ec9963584ac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e8491-d619-776a-bac3-868dfdebcf77.webp",
      "image_media": {
        "alt_text": "Gym equipment including an elliptical, treadmill, and dumbbell rack.",
        "public_id": "019e8491-d619-776a-bac3-868dfdebcf77",
        "storage_key": "property/6737460151192627/019e8491-d619-776a-bac3-868dfdebcf77.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines and free weights.",
      "link": "",
      "alt_text": "Gym equipment including an elliptical, treadmill, and dumbbell rack.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_98c44c00-eba2-4ec9-9809-04efb478e0a9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e8491-bbce-7777-9910-437c909b5dc6.webp",
      "image_media": {
        "alt_text": "Exterior of a two-story apartment building with white siding, black railings, and an outdoor staircase.",
        "public_id": "019e8491-bbce-7777-9910-437c909b5dc6",
        "storage_key": "property/6737460151192627/019e8491-bbce-7777-9910-437c909b5dc6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "View of the exterior of a two-story apartment building featuring white siding, a central outdoor staircase, and well-maintained landscaping.",
      "link": "",
      "alt_text": "Exterior of a two-story apartment building with white siding, black railings, and an outdoor staircase.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_11cebd3b-8983-4f43-a718-d21a31884f71",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e8491-b854-7636-955d-991ac0c59795.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with blue lounge chairs and picnic tables.",
        "public_id": "019e8491-b854-7636-955d-991ac0c59795",
        "storage_key": "property/6737460151192627/019e8491-b854-7636-955d-991ac0c59795.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and convenient picnic tables. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Outdoor swimming pool with blue lounge chairs and picnic tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_41bfb4e5-88b8-4cd4-add7-aef21d0d6b83",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e8491-b6c7-75cb-817a-3ecadf91ad15.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables.",
        "public_id": "019e8491-b6c7-75cb-817a-3ecadf91ad15",
        "storage_key": "property/6737460151192627/019e8491-b6c7-75cb-817a-3ecadf91ad15.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and shaded seating areas. Perfect for relaxing on sunny days.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b00f7a9c-deef-4363-a07a-4b589db2e009",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e8491-b849-7388-8f28-bf16c4fe6266.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with picnic table and benches in a fenced-in grassy area with a building in the background.",
        "public_id": "019e8491-b849-7388-8f28-bf16c4fe6266",
        "storage_key": "property/6737460151192627/019e8491-b849-7388-8f28-bf16c4fe6266.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings at the community picnic area, complete with a table and benches, located in a fenced-in space.",
      "link": "",
      "alt_text": "Outdoor seating area with picnic table and benches in a fenced-in grassy area with a building in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e577057e-17ff-49c7-a23e-d93300b9d122",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e8491-b216-739a-ac7f-e481035fb924.webp",
      "image_media": {
        "alt_text": "Treadmill, elliptical, weight rack, and multi-station gym equipment in a fitness center.",
        "public_id": "019e8491-b216-739a-ac7f-e481035fb924",
        "storage_key": "property/6737460151192627/019e8491-b216-739a-ac7f-e481035fb924.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, equipped with modern cardio machines and strength training equipment for a complete workout.",
      "link": "",
      "alt_text": "Treadmill, elliptical, weight rack, and multi-station gym equipment in a fitness center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6dd06fcd-d854-4a7f-8713-4f557f5aea72",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e8491-b27c-761d-b0c6-e886060b865f.webp",
      "image_media": {
        "alt_text": "Exterior of a two-story apartment building with white siding and dark shutters.",
        "public_id": "019e8491-b27c-761d-b0c6-e886060b865f",
        "storage_key": "property/6737460151192627/019e8491-b27c-761d-b0c6-e886060b865f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of the apartment buildings, showcasing the clean white siding, dark shutters, and convenient outdoor staircases.",
      "link": "",
      "alt_text": "Exterior of a two-story apartment building with white siding and dark shutters.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0382eaa9-aaec-42b2-8e8d-3f513e23563b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e8491-b2e9-76af-a682-38bb828ab6a4.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with blue lounge chairs and tables in front of apartment buildings.",
        "public_id": "019e8491-b2e9-76af-a682-38bb828ab6a4",
        "storage_key": "property/6737460151192627/019e8491-b2e9-76af-a682-38bb828ab6a4.webp",
        "width": 3054,
        "height": 2036
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and shaded seating areas. Perfect for relaxing and unwinding.",
      "link": "",
      "alt_text": "Outdoor swimming pool with blue lounge chairs and tables in front of apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_951163ac-1c2d-4d1d-ac63-56ea760cb0fb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e8491-b3ab-709c-8b45-bd6348520df1.webp",
      "image_media": {
        "alt_text": "Exterior of a white apartment building with external staircases and balconies.",
        "public_id": "019e8491-b3ab-709c-8b45-bd6348520df1",
        "storage_key": "property/6737460151192627/019e8491-b3ab-709c-8b45-bd6348520df1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of a white apartment building, featuring walkways, green lawns, and mature trees. Ideal for showcasing the property's grounds and architecture.",
      "link": "",
      "alt_text": "Exterior of a white apartment building with external staircases and balconies.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_cdbf78ca-3e4a-4f06-a0a8-34077d6deab0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "MarketPlace Grill",
      "poi_type": "Restaurants",
      "poi_address": "600 Skyline Dr, Conway, AR 72032, USA",
      "poi_short_description": "Casual, family-friendly chain outpost serving a wide-ranging American menu with Southern flair.",
      "poi_long_description": "Casual, family-friendly chain outpost serving a wide-ranging American menu with Southern flair.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df6-fd8f-70eb-b3f7-47442a16ae5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df6-fd8f-70eb-b3f7-47442a16ae5b",
        "storage_key": "property/6737460151192627/019e1df6-fd8f-70eb-b3f7-47442a16ae5b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.marketplacegrill.com/?y_source=1_MTQ2OTg4NTMtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=8349755870580856750&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marketplace-grill",
      "poi_latitude": "35.1129956",
      "poi_longitude": "-92.4334179",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 501-336-0011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6dd8-7169-9a22-04fceb6065c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6dd8-7169-9a22-04fceb6065c1",
        "storage_key": "property/6737460151192627/019e1df5-6dd8-7169-9a22-04fceb6065c1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4zx_O42B0ocRrlc0s7lK4HM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_c191d6ec-04b2-478a-9196-5f12ba4302a6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "The Rogue Roundabout",
      "poi_type": "Restaurants",
      "poi_address": "804 Chestnut St, Conway, AR 72032, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df6-f553-76b3-bfa3-b92eec708f33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df6-f553-76b3-bfa3-b92eec708f33",
        "storage_key": "property/6737460151192627/019e1df6-f553-76b3-bfa3-b92eec708f33.webp",
        "width": 1280,
        "height": 789
      },
      "poi_business_url": "https://www.therogueroundabout.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9373214476837473697&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-rogue-roundabout",
      "poi_latitude": "35.090132",
      "poi_longitude": "-92.4392089",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-358-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6dd8-7169-9a22-04fceb6065c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6dd8-7169-9a22-04fceb6065c1",
        "storage_key": "property/6737460151192627/019e1df5-6dd8-7169-9a22-04fceb6065c1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3QDF_rKD0ocRoU1yv-dYFII",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_5bc59412-1a8c-4ba6-be8b-2080f9180cae",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "The Patio Café",
      "poi_type": "Restaurants",
      "poi_address": "1156 Front St, Conway, AR 72032, USA",
      "poi_short_description": "Relaxed, family-friendly cafe for homemade staples, including pancakes, eggs benedict and French toast, served on a patio.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-02f5-7048-81a4-3f93361473e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-02f5-7048-81a4-3f93361473e0",
        "storage_key": "property/6737460151192627/019e1df7-02f5-7048-81a4-3f93361473e0.webp",
        "width": 1040,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11829378641760593494&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-patio-caf",
      "poi_latitude": "35.095251",
      "poi_longitude": "-92.442763",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 501-358-3556",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-42c6-7149-9dfb-c3214fed38db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-42c6-7149-9dfb-c3214fed38db",
        "storage_key": "property/6737460151192627/019e1df7-42c6-7149-9dfb-c3214fed38db.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ51GO5hiC0ocRVqa7LzNlKqQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_dd0377df-3658-41b2-9d85-9952155e0c3b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Level Ground Coffee",
      "poi_type": "Restaurants",
      "poi_address": "1116 Oak St, Conway, AR 72032, USA",
      "poi_short_description": "Coffeehouse with a cozy, casual atmosphere, serving breakfast and desserts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df6-f60b-76ec-b328-7361bcb1961c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df6-f60b-76ec-b328-7361bcb1961c",
        "storage_key": "property/6737460151192627/019e1df6-f60b-76ec-b328-7361bcb1961c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.levelgroundcoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8433968322856756906&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "level-ground-coffee",
      "poi_latitude": "35.0910506",
      "poi_longitude": "-92.4404649",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 501-426-5317",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-42c6-7149-9dfb-c3214fed38db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-42c6-7149-9dfb-c3214fed38db",
        "storage_key": "property/6737460151192627/019e1df7-42c6-7149-9dfb-c3214fed38db.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ7w8Ud-SD0ocRqibGKoF5C3U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_1181a8e5-a889-4213-9ae7-9c240379b421",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "La Pista Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "1050 Ellis Ave suite #110, Conway, AR 72032, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df6-f790-7498-9a8f-a624575d02ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df6-f790-7498-9a8f-a624575d02ef",
        "storage_key": "property/6737460151192627/019e1df6-f790-7498-9a8f-a624575d02ef.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://lapistapizzeria.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12774841097459650186&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-pista-pizzeria",
      "poi_latitude": "35.1031891",
      "poi_longitude": "-92.438812",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 501-358-5577",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6dd8-7169-9a22-04fceb6065c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6dd8-7169-9a22-04fceb6065c1",
        "storage_key": "property/6737460151192627/019e1df5-6dd8-7169-9a22-04fceb6065c1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJg_xHGH2B0ocRis4kTEtaSbE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_3835103b-a0f8-4559-ace4-3c9355d9eaeb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Taziki's Mediterranean Cafe - Conway",
      "poi_type": "Restaurants",
      "poi_address": "724 Oak St, Conway, AR 72032, USA",
      "poi_short_description": "Comfy chain eatery providing made-to-order gyros & other Mediterranean dishes plus beer & wine.",
      "poi_long_description": "Comfy chain eatery providing made-to-order gyros & other Mediterranean dishes plus beer & wine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-0350-7642-bb3c-613af267bdef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-0350-7642-bb3c-613af267bdef",
        "storage_key": "property/6737460151192627/019e1df7-0350-7642-bb3c-613af267bdef.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://tazikiscafe.com/location/conway/",
      "poi_directions_map_url": "https://maps.google.com/?cid=696006491247800064&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tazikis-mediterranean-cafe---conway",
      "poi_latitude": "35.092102",
      "poi_longitude": "-92.435326",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-327-1829",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6dd8-7169-9a22-04fceb6065c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6dd8-7169-9a22-04fceb6065c1",
        "storage_key": "property/6737460151192627/019e1df5-6dd8-7169-9a22-04fceb6065c1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ44JlyiSC0ocRAO8wWDe2qAk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_cc5e35eb-4068-4d03-80bd-f19e647892a5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Whole Hog Cafe - Conway",
      "poi_type": "Restaurants",
      "poi_address": "150 E Oak St SUITE A, Conway, AR 72032, USA",
      "poi_short_description": "Outpost of a local BBQ chain dishing out ribs, brisket & other standards in a laid-back atmosphere.",
      "poi_long_description": "Outpost of a local BBQ chain dishing out ribs, brisket & other standards in a laid-back atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df6-f4ea-777b-990f-a12f8911f9cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df6-f4ea-777b-990f-a12f8911f9cf",
        "storage_key": "property/6737460151192627/019e1df6-f4ea-777b-990f-a12f8911f9cf.webp",
        "width": 1280,
        "height": 941
      },
      "poi_business_url": "http://wholehogconway.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=490238674103761761&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whole-hog-cafe---conway",
      "poi_latitude": "35.093482",
      "poi_longitude": "-92.4257183",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 501-513-0600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6dd8-7169-9a22-04fceb6065c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6dd8-7169-9a22-04fceb6065c1",
        "storage_key": "property/6737460151192627/019e1df5-6dd8-7169-9a22-04fceb6065c1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZbVAQy6C0ocRYfscCXqtzQY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_f01e9658-55bf-4f5f-b394-ef554b1ab8e2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Mike's Place",
      "poi_type": "Restaurants",
      "poi_address": "808 Front St, Conway, AR 72032, USA",
      "poi_short_description": "Cajun-style seafood, steaks & wood-fired pizza served in upscale quarters with a New Orleans vibe.",
      "poi_long_description": "Cajun-style seafood, steaks & wood-fired pizza served in upscale quarters with a New Orleans vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df6-fbeb-744a-a0b8-3d140c1808d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df6-fbeb-744a-a0b8-3d140c1808d2",
        "storage_key": "property/6737460151192627/019e1df6-fbeb-744a-a0b8-3d140c1808d2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://mikesplaceconway.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10391194004312193916&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mikes-place",
      "poi_latitude": "35.08979679999999",
      "poi_longitude": "-92.4403361",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-269-6453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6dd8-7169-9a22-04fceb6065c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6dd8-7169-9a22-04fceb6065c1",
        "storage_key": "property/6737460151192627/019e1df5-6dd8-7169-9a22-04fceb6065c1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJk2nRZj2C0ocRfHsyW-TvNJA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cajun_restaurant"
    },
    {
      "id": "custom_c6b09c45-1c67-4aab-bd5e-be1600f73238",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Stoby's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "805 Donaghey Ave, Conway, AR 72034, USA",
      "poi_short_description": "Long-running diner serving Southern-style American grub, including cheese dip & baked goods.",
      "poi_long_description": "Long-running diner serving Southern-style American grub, including cheese dip & baked goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df4-efaa-7327-99bf-1411cc245848.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-efaa-7327-99bf-1411cc245848",
        "storage_key": "property/6737460151192627/019e1df4-efaa-7327-99bf-1411cc245848.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://stobys.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11470104909518115083&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stobys-restaurant",
      "poi_latitude": "35.0885518",
      "poi_longitude": "-92.454139",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 501-327-5447",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6dd8-7169-9a22-04fceb6065c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6dd8-7169-9a22-04fceb6065c1",
        "storage_key": "property/6737460151192627/019e1df5-6dd8-7169-9a22-04fceb6065c1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJT10zHA-C0ocRC5FK3KT_LZ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_036d93c9-78af-480e-8f1b-9a24f94d6ead",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Hideaway Pizza",
      "poi_type": "Restaurants",
      "poi_address": "1170 S Amity Rd, Conway, AR 72032, USA",
      "poi_short_description": "Local chain featuring build-your-own pies, a variety of Italian fare & a kids' menu.",
      "poi_long_description": "Local chain featuring build-your-own pies, a variety of Italian fare & a kids' menu.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df6-fa75-7736-8df9-698ab7726251.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df6-fa75-7736-8df9-698ab7726251",
        "storage_key": "property/6737460151192627/019e1df6-fa75-7736-8df9-698ab7726251.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hideawaypizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4432225120785765417&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hideaway-pizza",
      "poi_latitude": "35.0644009",
      "poi_longitude": "-92.414389",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 501-697-4444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6dd8-7169-9a22-04fceb6065c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6dd8-7169-9a22-04fceb6065c1",
        "storage_key": "property/6737460151192627/019e1df5-6dd8-7169-9a22-04fceb6065c1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ411sM6mD0ocRKZT_sENtgj0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_7899b470-028d-42de-b17e-57d63751e396",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Pasta Grill",
      "poi_type": "Restaurants",
      "poi_address": "915 Front St, Conway, AR 72032, USA",
      "poi_short_description": "Rustic, brick-walled Italian restaurant featuring pasta dishes, steaks, seafood & desserts.",
      "poi_long_description": "Rustic, brick-walled Italian restaurant featuring pasta dishes, steaks, seafood & desserts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df6-fc58-7184-9c4c-597600a670cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df6-fc58-7184-9c4c-597600a670cf",
        "storage_key": "property/6737460151192627/019e1df6-fc58-7184-9c4c-597600a670cf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.pastagrillrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=634649580512818545&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pasta-grill",
      "poi_latitude": "35.091137",
      "poi_longitude": "-92.441368",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 501-205-8751",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6dd8-7169-9a22-04fceb6065c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6dd8-7169-9a22-04fceb6065c1",
        "storage_key": "property/6737460151192627/019e1df5-6dd8-7169-9a22-04fceb6065c1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbzHa-ReC0ocRcTVRU266zgg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_8e8a43c7-eb57-4b5f-90ef-522060f67618",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Bulgogi Korean BBQ",
      "poi_type": "Restaurants",
      "poi_address": "317 Oak St Suite 1, Conway, AR 72032, USA",
      "poi_short_description": "Korean BBQ dishes and other Asian fare share the menu at this informal restaurant.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-0604-7508-beec-4ce6ed723461.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-0604-7508-beec-4ce6ed723461",
        "storage_key": "property/6737460151192627/019e1df7-0604-7508-beec-4ce6ed723461.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://www.clover.com/online-ordering/bulgogi-conway",
      "poi_directions_map_url": "https://maps.google.com/?cid=13405442507952761161&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bulgogi-korean-bbq",
      "poi_latitude": "35.0913148",
      "poi_longitude": "-92.430491",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-358-5923",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6dd8-7169-9a22-04fceb6065c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6dd8-7169-9a22-04fceb6065c1",
        "storage_key": "property/6737460151192627/019e1df5-6dd8-7169-9a22-04fceb6065c1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmYeIrWuD0ocRSSlyl--yCbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "korean_restaurant"
    },
    {
      "id": "custom_8439a36c-0e29-40ac-943b-0d638a142187",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Umami Sushi Lounge & Grill Fusion in Conway Arkansas",
      "poi_type": "Restaurants",
      "poi_address": "500 Amity Rd #1, Conway, AR 72032, USA",
      "poi_short_description": "Japanese sushi & entrees served in a sleek, casual restaurant with hibachi grill tables.",
      "poi_long_description": "Japanese sushi & entrees served in a sleek, casual restaurant with hibachi grill tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-04ac-7437-a73d-7e9c5de9e0df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-04ac-7437-a73d-7e9c5de9e0df",
        "storage_key": "property/6737460151192627/019e1df7-04ac-7437-a73d-7e9c5de9e0df.webp",
        "width": 1280,
        "height": 875
      },
      "poi_business_url": "https://www.umamiconwayar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18430429717778648856&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "umami-sushi-lounge--grill-fusion-in-conway-arkansas",
      "poi_latitude": "35.0868414",
      "poi_longitude": "-92.4158025",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 501-358-3880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6dd8-7169-9a22-04fceb6065c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6dd8-7169-9a22-04fceb6065c1",
        "storage_key": "property/6737460151192627/019e1df5-6dd8-7169-9a22-04fceb6065c1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1fISq86D0ocRGM__AS4Kxv8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_5b738528-e1c6-4b40-adb7-1211dccfcbfc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "David's Burgers",
      "poi_type": "Restaurants",
      "poi_address": "1100 Skyline Dr, Conway, AR 72032, USA",
      "poi_short_description": "Retro, counter-serve chain offering a simple menu of housemade beef burgers & fries, plus ice cream.",
      "poi_long_description": "Retro, counter-serve chain offering a simple menu of housemade beef burgers & fries, plus ice cream.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-0740-711b-b2a5-23e9f356b133.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-0740-711b-b2a5-23e9f356b133",
        "storage_key": "property/6737460151192627/019e1df7-0740-711b-b2a5-23e9f356b133.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://davidsburgers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11352569427605572020&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "davids-burgers",
      "poi_latitude": "35.1106928",
      "poi_longitude": "-92.4402605",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 501-327-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6dd8-7169-9a22-04fceb6065c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6dd8-7169-9a22-04fceb6065c1",
        "storage_key": "property/6737460151192627/019e1df5-6dd8-7169-9a22-04fceb6065c1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4zx_O42B0ocRtMlj9L5tjJ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_7a5819c9-c825-4516-b733-86f6620a2735",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Don Pepe’s Gourmet Burritos & Tacos",
      "poi_type": "Restaurants",
      "poi_address": "2525 Prince St, Conway, AR 72034, USA",
      "poi_short_description": "Unfussy, quick-serve operation serving Mexican staples such as hearty burritos & tacos.",
      "poi_long_description": "Unfussy, quick-serve operation serving Mexican staples such as hearty burritos & tacos.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-08dd-774b-a3f9-5ca2c0181402.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-08dd-774b-a3f9-5ca2c0181402",
        "storage_key": "property/6737460151192627/019e1df7-08dd-774b-a3f9-5ca2c0181402.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.donpepesarkansas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1246451058804625948&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "don-pepes-gourmet-burritos--tacos",
      "poi_latitude": "35.0918089",
      "poi_longitude": "-92.4639932",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 501-358-6007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6dd8-7169-9a22-04fceb6065c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6dd8-7169-9a22-04fceb6065c1",
        "storage_key": "property/6737460151192627/019e1df5-6dd8-7169-9a22-04fceb6065c1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4y7O1geC0ocRHJL1TaJITBE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_6b9f8941-48d6-435a-a11d-9523f0757f5b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Kroger Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "855 Salem Rd, Conway, AR 72034, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df4-ebf1-738e-b617-e2c22348c2ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-ebf1-738e-b617-e2c22348c2ff",
        "storage_key": "property/6737460151192627/019e1df4-ebf1-738e-b617-e2c22348c2ff.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/ar/conway/conway-marketplace/025/00625?cid=loc_02500625_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=2165103355835332026&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger-marketplace",
      "poi_latitude": "35.0892416",
      "poi_longitude": "-92.4725659",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 501-329-3628",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6ea7-722b-a5ea-0c2ddf2a10a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6ea7-722b-a5ea-0c2ddf2a10a7",
        "storage_key": "property/6737460151192627/019e1df5-6ea7-722b-a5ea-0c2ddf2a10a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz20fTQ9-zYcRujWS6gf-Cx4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_285f7bf8-9284-4319-8b26-1d23ff49c07a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "1272 S Amity Rd, Conway, AR 72032, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-0c4a-7598-a382-9f91eb891fa6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-0c4a-7598-a382-9f91eb891fa6",
        "storage_key": "property/6737460151192627/019e1df7-0c4a-7598-a382-9f91eb891fa6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ar/conway/1272-south-amity-road/fe56",
      "poi_directions_map_url": "https://maps.google.com/?cid=1923348027340687637&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "35.06276",
      "poi_longitude": "-92.41327",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6ea7-722b-a5ea-0c2ddf2a10a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6ea7-722b-a5ea-0c2ddf2a10a7",
        "storage_key": "property/6737460151192627/019e1df5-6ea7-722b-a5ea-0c2ddf2a10a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJERxIo7qD0ocRFQkXLdcasRo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_5e9918ae-3668-49ce-baf4-bead7068ef0b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "2550 Prince St, Conway, AR 72034, USA",
      "poi_short_description": "Neighborhood store for groceries, produce, toys, clothing, and more, plus check cashing.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df4-f400-7551-b4c2-8e84956aa097.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-f400-7551-b4c2-8e84956aa097",
        "storage_key": "property/6737460151192627/019e1df4-f400-7551-b4c2-8e84956aa097.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/3168-conway-ar/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=12857708241722764984&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "35.0946579",
      "poi_longitude": "-92.4629644",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 501-205-7262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6ea7-722b-a5ea-0c2ddf2a10a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6ea7-722b-a5ea-0c2ddf2a10a7",
        "storage_key": "property/6737460151192627/019e1df5-6ea7-722b-a5ea-0c2ddf2a10a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN5xWtPl9zYcRuG5_1YXBb7I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_ee7aae31-95bd-4584-aa1d-37831fe6580e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "501 Elsinger Blvd, Conway, AR 72032, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-0b9c-7490-b992-1af205106461.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-0b9c-7490-b992-1af205106461",
        "storage_key": "property/6737460151192627/019e1df7-0b9c-7490-b992-1af205106461.webp",
        "width": 1280,
        "height": 626
      },
      "poi_business_url": "https://www.target.com/sl/conway/1891",
      "poi_directions_map_url": "https://maps.google.com/?cid=5514527007218763977&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "35.086279",
      "poi_longitude": "-92.41445",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 501-328-5739",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6ebd-7129-b16b-1985acb0dd47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6ebd-7129-b16b-1985acb0dd47",
        "storage_key": "property/6737460151192627/019e1df5-6ebd-7129-b16b-1985acb0dd47.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJFZWLNMmD0ocRyYiSiRiJh0w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_ea30cdfd-3da8-47b3-a8b7-c3ec3359ecf1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "501 Elsinger Blvd, Conway, AR 72032, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-0b91-77de-9ff9-08969f77f517.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-0b91-77de-9ff9-08969f77f517",
        "storage_key": "property/6737460151192627/019e1df7-0b91-77de-9ff9-08969f77f517.webp",
        "width": 1280,
        "height": 990
      },
      "poi_business_url": "https://www.cvs.com/store-locator/conway-ar-pharmacies/501-elsinger-blvd-conway-ar-72032/storeid=17011?WT.mc_id=LS_GOOGLE_RX_17011",
      "poi_directions_map_url": "https://maps.google.com/?cid=18395545745569783797&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "35.086279",
      "poi_longitude": "-92.41445",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 501-328-5316",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-42f8-73ed-b68e-41bb07052b94.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-42f8-73ed-b68e-41bb07052b94",
        "storage_key": "property/6737460151192627/019e1df7-42f8-73ed-b68e-41bb07052b94.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFZWLNMmD0ocR9Z8iTmQbSv8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_c7a8f3e7-9e06-4297-a8f2-9713f7348097",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "505 Salem Rd, Conway, AR 72034, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-0fe5-7256-b08e-799dbc2fec20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-0fe5-7256-b08e-799dbc2fec20",
        "storage_key": "property/6737460151192627/019e1df7-0fe5-7256-b08e-799dbc2fec20.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-505+salem+rd-conway-ar-72034/id=10170",
      "poi_directions_map_url": "https://maps.google.com/?cid=1237371258544757864&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "35.0855468",
      "poi_longitude": "-92.4727747",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-328-3117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6fc1-70ac-a1e4-2575b0366bd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6fc1-70ac-a1e4-2575b0366bd8",
        "storage_key": "property/6737460151192627/019e1df5-6fc1-70ac-a1e4-2575b0366bd8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH9Bhfu59zYcRaJzWkJoGLBE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_48347a6b-710a-4b85-bbe8-477f58d97d3d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Maverik Adventure's First Stop",
      "poi_type": "Shopping & Retail",
      "poi_address": "2050 Dave Ward Dr, Conway, AR 72034, USA",
      "poi_short_description": "Gas station & convenience store chain offering hot & cold snacks, plus coffees & sodas.",
      "poi_long_description": "Gas station & convenience store chain offering hot & cold snacks, plus coffees & sodas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-1027-740a-914f-3e9d029052a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-1027-740a-914f-3e9d029052a5",
        "storage_key": "property/6737460151192627/019e1df7-1027-740a-914f-3e9d029052a5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.maverik.com/ar/conway/2050-dave-ward-dr.",
      "poi_directions_map_url": "https://maps.google.com/?cid=7449273089843003715&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maverik-adventures-first-stop",
      "poi_latitude": "35.0707636",
      "poi_longitude": "-92.453925",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 501-932-0114",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-42c5-7278-918d-62dc13e677ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-42c5-7278-918d-62dc13e677ac",
        "storage_key": "property/6737460151192627/019e1df7-42c5-7278-918d-62dc13e677ac.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJTY3N6nCC0ocRQwH4QmgiYWc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_65891849-feef-42e4-a6b8-4f4e0c9187d3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Petco",
      "poi_type": "Shopping & Retail",
      "poi_address": "1290 S Amity Rd, Conway, AR 72032, USA",
      "poi_short_description": "Chain with pet food & supplies such as toys, beds & pet technology products, plus medication.",
      "poi_long_description": "Chain with pet food & supplies such as toys, beds & pet technology products, plus medication.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-10fb-75ca-8523-ca9fd55ba153.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-10fb-75ca-8523-ca9fd55ba153",
        "storage_key": "property/6737460151192627/019e1df7-10fb-75ca-8523-ca9fd55ba153.webp",
        "width": 1280,
        "height": 1023
      },
      "poi_business_url": "https://stores.petco.com/ar/conway/pet-supplies-conway-ar-2521.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=7513588834724106103&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "petco",
      "poi_latitude": "35.0627082",
      "poi_longitude": "-92.4121837",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 501-205-7126",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6ebd-7129-b16b-1985acb0dd47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6ebd-7129-b16b-1985acb0dd47",
        "storage_key": "property/6737460151192627/019e1df5-6ebd-7129-b16b-1985acb0dd47.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJaX4N7KiD0ocRd08SijyhRWg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pet_store"
    },
    {
      "id": "custom_7453d96f-9d33-464d-9c07-48420d141285",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Michaels",
      "poi_type": "Shopping & Retail",
      "poi_address": "Lewis Crossing Shopping Center, 1284 S Amity Rd, Conway, AR 72032, USA",
      "poi_short_description": "Chain retailer carrying art & hobby supplies plus home decor (most offer classes & custom framing).",
      "poi_long_description": "Chain retailer carrying art & hobby supplies plus home decor (most offer classes & custom framing).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-14de-702e-b80f-06fe6ef82805.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-14de-702e-b80f-06fe6ef82805",
        "storage_key": "property/6737460151192627/019e1df7-14de-702e-b80f-06fe6ef82805.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.michaels.com/AR/Conway/1295/?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=1102270837600054546&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "michaels",
      "poi_latitude": "35.0627064",
      "poi_longitude": "-92.4124959",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 501-697-9400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6ebd-7129-b16b-1985acb0dd47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6ebd-7129-b16b-1985acb0dd47",
        "storage_key": "property/6737460151192627/019e1df5-6ebd-7129-b16b-1985acb0dd47.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJGbZt5qiD0ocREm1smXwNTA8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_3a5e58d8-872c-4892-860f-89f8b0b5d40f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "3900 Dave Ward Dr, Conway, AR 72034, USA",
      "poi_short_description": "Grocery, sporting goods and toy store boasting a wide-ranging selection of other housewares.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-12eb-74a7-b66c-a048b234186b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-12eb-74a7-b66c-a048b234186b",
        "storage_key": "property/6737460151192627/019e1df7-12eb-74a7-b66c-a048b234186b.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/2575-conway-ar/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=17384216655583586691&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.0727703",
      "poi_longitude": "-92.4953521",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 501-328-9570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6ebd-7129-b16b-1985acb0dd47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6ebd-7129-b16b-1985acb0dd47",
        "storage_key": "property/6737460151192627/019e1df5-6ebd-7129-b16b-1985acb0dd47.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZ2S08KN-0ocRgyl9VvEkQfE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_e671234d-862a-47f5-b3f3-55bbb03c6440",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Bob and Betty Courtway Middle School",
      "poi_type": "Education",
      "poi_address": "1200 Bob Courtway Dr, Conway, AR 72032, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.conwayschools.org/cms",
      "poi_directions_map_url": "https://maps.google.com/?cid=12635548106904415565&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bob-and-betty-courtway-middle-school",
      "poi_latitude": "35.0953727",
      "poi_longitude": "-92.4117563",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 501-450-4832",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6eac-744e-8902-b055c15ce740.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6eac-744e-8902-b055c15ce740",
        "storage_key": "property/6737460151192627/019e1df5-6eac-744e-8902-b055c15ce740.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJgTj1nNCD0ocRTa1lpg58Wq8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_83c535ee-04e8-4453-94ed-b4b61e14e2f1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Theodore Jones Elementary School",
      "poi_type": "Education",
      "poi_address": "1800 Freyaldenhoven Ln, Conway, AR 72032, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.conwayschools.org/o/tjes",
      "poi_directions_map_url": "https://maps.google.com/?cid=11790278315150386212&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "theodore-jones-elementary-school",
      "poi_latitude": "35.1030328",
      "poi_longitude": "-92.4140945",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-450-6645",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6eac-744e-8902-b055c15ce740.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6eac-744e-8902-b055c15ce740",
        "storage_key": "property/6737460151192627/019e1df5-6eac-744e-8902-b055c15ce740.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJBRF8O9aD0ocRJKSH-ah7n6M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_717d03c2-475b-44b2-9a58-85da9ccfaf8c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Florence Mattison Elementary",
      "poi_type": "Education",
      "poi_address": "2001 Florence Mattison Dr, Conway, AR 72032, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.conwayschools.org/o/pfmes",
      "poi_directions_map_url": "https://maps.google.com/?cid=17739920256622949017&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "florence-mattison-elementary",
      "poi_latitude": "35.0880668",
      "poi_longitude": "-92.3987377",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 501-450-4820",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6eac-744e-8902-b055c15ce740.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6eac-744e-8902-b055c15ce740",
        "storage_key": "property/6737460151192627/019e1df5-6eac-744e-8902-b055c15ce740.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJocD7pOmD0ocRmXLEt3vbMPY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_e9160d47-ebf8-4f32-aa9f-44340dfb8719",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Conway JR High School",
      "poi_type": "Education",
      "poi_address": "1815 Prince St, Conway, AR 72034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-16cd-709b-a766-0b4fa8ab3bc5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-16cd-709b-a766-0b4fa8ab3bc5",
        "storage_key": "property/6737460151192627/019e1df7-16cd-709b-a766-0b4fa8ab3bc5.webp",
        "width": 1280,
        "height": 597
      },
      "poi_business_url": "https://www.conwayschools.org/o/cjhs",
      "poi_directions_map_url": "https://maps.google.com/?cid=7265398464180936967&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "conway-jr-high-school",
      "poi_latitude": "35.0920373",
      "poi_longitude": "-92.4491828",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 501-450-4860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6fc1-70ac-a1e4-2575b0366bd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6fc1-70ac-a1e4-2575b0366bd8",
        "storage_key": "property/6737460151192627/019e1df5-6fc1-70ac-a1e4-2575b0366bd8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSQrVfACD0ocRB2Es0Wjh02Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "point_of_interest"
    },
    {
      "id": "custom_6cdb9718-58e7-4b36-86a7-112a27ab2201",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Childcare Network",
      "poi_type": "Education",
      "poi_address": "1150 AR-365, Conway, AR 72032, USA",
      "poi_short_description": "Chain preschool, child day care center featuring a curriculum of activities that combine learning and fun, plus an after-school homework assistance program.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-16d2-70e1-b129-3d7413047e05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-16d2-70e1-b129-3d7413047e05",
        "storage_key": "property/6737460151192627/019e1df7-16d2-70e1-b129-3d7413047e05.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://schools.childcarenetwork.com/ar/conway/1150-highway-365-s",
      "poi_directions_map_url": "https://maps.google.com/?cid=5444735480551219964&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childcare-network",
      "poi_latitude": "35.0631168",
      "poi_longitude": "-92.4263155",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 501-328-5075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6eac-744e-8902-b055c15ce740.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6eac-744e-8902-b055c15ce740",
        "storage_key": "property/6737460151192627/019e1df5-6eac-744e-8902-b055c15ce740.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJm-Eq3FWC0ocR_KI4dhKWj0s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_1613d211-1a35-4db2-88cf-092fefd8fce3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Little Dumplings",
      "poi_type": "Education",
      "poi_address": "9 Odom Rd, Conway, AR 72032, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://littledumplingschildcarecenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9546492188125616539&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-dumplings",
      "poi_latitude": "35.0636015",
      "poi_longitude": "-92.3831664",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 501-764-4142",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6eac-744e-8902-b055c15ce740.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6eac-744e-8902-b055c15ce740",
        "storage_key": "property/6737460151192627/019e1df5-6eac-744e-8902-b055c15ce740.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJucQglYCD0ocRm9lEzBD0e4Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_9f765e9a-3968-4cc2-8b8e-288d708a1c1d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Second Blessings Daycare",
      "poi_type": "Education",
      "poi_address": "1158 Harrison St, Conway, AR 72032, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-19aa-721a-8f4c-7c29bb57c3d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-19aa-721a-8f4c-7c29bb57c3d5",
        "storage_key": "property/6737460151192627/019e1df7-19aa-721a-8f4c-7c29bb57c3d5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5891619694927227860&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "second-blessings-daycare",
      "poi_latitude": "35.094805",
      "poi_longitude": "-92.438932",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 313-574-5581",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6eac-744e-8902-b055c15ce740.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6eac-744e-8902-b055c15ce740",
        "storage_key": "property/6737460151192627/019e1df5-6eac-744e-8902-b055c15ce740.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmbGBxWCD0ocR1CvVu-U8w1E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_65ec8ab0-75c5-42a1-ab9e-d30276453197",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Hendrix College",
      "poi_type": "Education",
      "poi_address": "1600 Washington Ave, Conway, AR 72032, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df4-f5a0-72ee-8c73-ae3fc6f48311.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-f5a0-72ee-8c73-ae3fc6f48311",
        "storage_key": "property/6737460151192627/019e1df4-f5a0-72ee-8c73-ae3fc6f48311.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "https://www.hendrix.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12084038531629622476&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hendrix-college",
      "poi_latitude": "35.1017695",
      "poi_longitude": "-92.44072",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 501-329-6811",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6eac-744e-8902-b055c15ce740.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6eac-744e-8902-b055c15ce740",
        "storage_key": "property/6737460151192627/019e1df5-6eac-744e-8902-b055c15ce740.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJO-EaUyCC0ocRzKTqQQUhs6c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_c3e7a68f-f38b-435b-b87d-9db23f91ac21",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "University of Central Arkansas",
      "poi_type": "Education",
      "poi_address": "201 Donaghey Ave, Conway, AR 72035, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df4-f9d5-764f-b494-442d39bb4a3b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-f9d5-764f-b494-442d39bb4a3b",
        "storage_key": "property/6737460151192627/019e1df4-f9d5-764f-b494-442d39bb4a3b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.uca.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6691214139866306738&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-central-arkansas",
      "poi_latitude": "35.0780939",
      "poi_longitude": "-92.4578916",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 501-450-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6eac-744e-8902-b055c15ce740.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6eac-744e-8902-b055c15ce740",
        "storage_key": "property/6737460151192627/019e1df5-6eac-744e-8902-b055c15ce740.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzeRo93SC0ocRsljNAs_321w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_2f877857-7686-4d40-831d-8e7785f53772",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Cinemark Towne Centre and XD",
      "poi_type": "Entertainment",
      "poi_address": "201 Skyline Dr Suite 25, Conway, AR 72032, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-193b-70bb-9810-908803564483.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-193b-70bb-9810-908803564483",
        "storage_key": "property/6737460151192627/019e1df7-193b-70bb-9810-908803564483.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cinemark.com/theatres/ar-conway/cinemark-towne-centre-and-xd?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTMwNDgtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=3247862190332428381&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-towne-centre-and-xd",
      "poi_latitude": "35.1096896",
      "poi_longitude": "-92.4306615",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 501-450-7558",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-42cf-77d9-9adf-963be5ab06e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-42cf-77d9-9adf-963be5ab06e4",
        "storage_key": "property/6737460151192627/019e1df7-42cf-77d9-9adf-963be5ab06e4.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJV5RjVYSB0ocRXcAvRnS5Ei0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_75872265-222f-450a-b060-2d7972cac3a1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Malys Family Entertainment Center",
      "poi_type": "Entertainment",
      "poi_address": "1040 Maly Curv, Conway, AR 72032, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-18cd-72c4-83ed-198a127665f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-18cd-72c4-83ed-198a127665f2",
        "storage_key": "property/6737460151192627/019e1df7-18cd-72c4-83ed-198a127665f2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://malysentertainmentconway.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6007100513472097883&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "malys-family-entertainment-center",
      "poi_latitude": "35.0650495",
      "poi_longitude": "-92.4081117",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 501-459-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6fc1-70ac-a1e4-2575b0366bd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6fc1-70ac-a1e4-2575b0366bd8",
        "storage_key": "property/6737460151192627/019e1df5-6fc1-70ac-a1e4-2575b0366bd8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ1VItAyD0ocRWy6SCxeCXVM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_b27c0af6-3e62-4eb8-997c-7b90fd246487",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Kings Live Music",
      "poi_type": "Entertainment",
      "poi_address": "1020 Front St, Conway, AR 72032, USA",
      "poi_short_description": "An eclectic selection of bands, plus karaoke & theme nights, in a relaxed space with a pub menu.",
      "poi_long_description": "An eclectic selection of bands, plus karaoke & theme nights, in a relaxed space with a pub menu.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-1d0c-7179-b4d2-d188ab7b03a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-1d0c-7179-b4d2-d188ab7b03a7",
        "storage_key": "property/6737460151192627/019e1df7-1d0c-7179-b4d2-d188ab7b03a7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://kingslivemusic.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=496105205508545431&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kings-live-music",
      "poi_latitude": "35.0922519",
      "poi_longitude": "-92.44150030000002",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 501-205-8512",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-42ce-75d9-bde1-9a9aa3c55d29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-42ce-75d9-bde1-9a9aa3c55d29",
        "storage_key": "property/6737460151192627/019e1df7-42ce-75d9-bde1-9a9aa3c55d29.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWTDTExiC0ocRlxuPUQ6F4gY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_73f40681-ab8f-4521-8769-fa28c304a647",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Reynolds Performance Hall",
      "poi_type": "Entertainment",
      "poi_address": "b g, 223 Beatrice Powell St, Conway, AR 72035, USA",
      "poi_short_description": "1,200-seat venue presenting big-name concerts, lectures, Broadway musicals & international acts.",
      "poi_long_description": "1,200-seat venue presenting big-name concerts, lectures, Broadway musicals & international acts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-1a76-773e-940b-85e4aef47db5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-1a76-773e-940b-85e4aef47db5",
        "storage_key": "property/6737460151192627/019e1df7-1a76-773e-940b-85e4aef47db5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://uca.edu/publicappearances/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9447969275769332363&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "reynolds-performance-hall",
      "poi_latitude": "35.07549850000001",
      "poi_longitude": "-92.4564572",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 501-450-3265",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6fc1-70ac-a1e4-2575b0366bd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6fc1-70ac-a1e4-2575b0366bd8",
        "storage_key": "property/6737460151192627/019e1df5-6fc1-70ac-a1e4-2575b0366bd8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi6hnFnSC0ocRiyIJs__tHYM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_2d0f9f69-a722-4d9f-aaf8-da87d7518ad6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Farris Center",
      "poi_type": "Entertainment",
      "poi_address": "Bruce St, Conway, AR 72035, USA",
      "poi_short_description": "Basketball arena also used for other events and graduation ceremonies at this college venue.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df4-fe9a-71f5-aac9-0360e604b73b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df4-fe9a-71f5-aac9-0360e604b73b",
        "storage_key": "property/6737460151192627/019e1df4-fe9a-71f5-aac9-0360e604b73b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7581131974682656770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "farris-center",
      "poi_latitude": "35.0818647",
      "poi_longitude": "-92.4594976",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6fc1-70ac-a1e4-2575b0366bd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6fc1-70ac-a1e4-2575b0366bd8",
        "storage_key": "property/6737460151192627/019e1df5-6fc1-70ac-a1e4-2575b0366bd8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9yyFRAuC0ocRAsBQSl2XNWk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_0662427f-9210-4753-8576-e527d80157fb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Baum Gallery",
      "poi_type": "Entertainment",
      "poi_address": "McCastlain Hall, 6 L A Niven Dr, Conway, AR 72034, USA",
      "poi_short_description": "Small facility at the University of Central Arkansas with exhibits showcasing regional artists.",
      "poi_long_description": "Small facility at the University of Central Arkansas with exhibits showcasing regional artists.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-1d2b-73bc-89ba-10782ce9ea06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-1d2b-73bc-89ba-10782ce9ea06",
        "storage_key": "property/6737460151192627/019e1df7-1d2b-73bc-89ba-10782ce9ea06.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.uca.edu/art/baum/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14608366733505214334&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baum-gallery",
      "poi_latitude": "35.0780836",
      "poi_longitude": "-92.4558763",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 501-450-5793",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6fc1-70ac-a1e4-2575b0366bd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6fc1-70ac-a1e4-2575b0366bd8",
        "storage_key": "property/6737460151192627/019e1df5-6fc1-70ac-a1e4-2575b0366bd8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUbWHOHOC0ocRfjc2SyVYu8o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_gallery"
    },
    {
      "id": "custom_771f2b82-4112-49e8-ae43-3908d1f2b62d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Faulkner County Museum",
      "poi_type": "Entertainment",
      "poi_address": "801 Locust St, Conway, AR 72034, USA",
      "poi_short_description": "1896 jail turned museum with county artifacts, photos, family history files & a model train display.",
      "poi_long_description": "1896 jail turned museum with county artifacts, photos, family history files & a model train display.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-20fc-748d-adfc-7c6b97da0bbc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-20fc-748d-adfc-7c6b97da0bbc",
        "storage_key": "property/6737460151192627/019e1df7-20fc-748d-adfc-7c6b97da0bbc.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "https://www.faulknerhistory.org/museum/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16277292883864634847&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "faulkner-county-museum",
      "poi_latitude": "35.0891836",
      "poi_longitude": "-92.4436024",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 501-329-5918",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-4326-76be-8498-0719ab74471e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-4326-76be-8498-0719ab74471e",
        "storage_key": "property/6737460151192627/019e1df7-4326-76be-8498-0719ab74471e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJmU-fsheC0ocR38W-F6OP5OE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_aa3591a0-47a6-41ca-9e71-3686ceadbeb7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Cadron Settlement Park",
      "poi_type": "Entertainment",
      "poi_address": "6200 Hwy 319 W, Conway, AR 72034, USA",
      "poi_short_description": "This 150-acre park features a reconstructed blockhouse, a boat ramp, hiking trails & more.",
      "poi_long_description": "This 150-acre park features a reconstructed blockhouse, a boat ramp, hiking trails & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-21d0-74aa-99ec-953cf0151c3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-21d0-74aa-99ec-953cf0151c3f",
        "storage_key": "property/6737460151192627/019e1df7-21d0-74aa-99ec-953cf0151c3f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.conwayparks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18394760510418608494&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cadron-settlement-park",
      "poi_latitude": "35.1077275",
      "poi_longitude": "-92.5444526",
      "poi_miles_from_property": "10.3",
      "poi_walking_minutes": "3 hours 49 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 501-450-6186",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6d91-759a-835f-260c76e20608.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6d91-759a-835f-260c76e20608",
        "storage_key": "property/6737460151192627/019e1df5-6d91-759a-835f-260c76e20608.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJt-i30VN5zYcRbmHifzlRR_8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_5f4ff34a-4c09-4034-ac2b-92900ade8d9c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Andy’s Frozen Custard",
      "poi_type": "Entertainment",
      "poi_address": "201 E Oak St, Conway, AR 72032, USA",
      "poi_short_description": "Frozen custard sundaes, concretes & more, plus a choice of toppings (with a drive-thru window).",
      "poi_long_description": "Frozen custard sundaes, concretes & more, plus a choice of toppings (with a drive-thru window).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-1e3e-7076-99f6-3cd53a85acb4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-1e3e-7076-99f6-3cd53a85acb4",
        "storage_key": "property/6737460151192627/019e1df7-1e3e-7076-99f6-3cd53a85acb4.webp",
        "width": 1123,
        "height": 1280
      },
      "poi_business_url": "https://locations.eatandys.com/ll/US/AR/Conway/201-E-Oak-Street",
      "poi_directions_map_url": "https://maps.google.com/?cid=8531726648006796391&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "andys-frozen-custard",
      "poi_latitude": "35.0913151",
      "poi_longitude": "-92.426358",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 501-504-6071",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6ebd-7129-b16b-1985acb0dd47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6ebd-7129-b16b-1985acb0dd47",
        "storage_key": "property/6737460151192627/019e1df5-6ebd-7129-b16b-1985acb0dd47.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJAQAQ-zGC0ocRZ-Qt7y7IZnY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dessert_shop"
    },
    {
      "id": "custom_b4aec200-21e8-45e7-b555-af29ac47760a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Baptist Health Medical Center-Conway",
      "poi_type": "Health and Wellness",
      "poi_address": "1555 Exchange Ave, Conway, AR 72032, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-0e90-743c-89a4-2b0b006fae61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df5-0e90-743c-89a4-2b0b006fae61",
        "storage_key": "property/6737460151192627/019e1df5-0e90-743c-89a4-2b0b006fae61.webp",
        "width": 1280,
        "height": 480
      },
      "poi_business_url": "https://www.baptist-health.org/find-care/location/Baptist-Health-Medical-Center-Conway",
      "poi_directions_map_url": "https://maps.google.com/?cid=1782155753846854487&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baptist-health-medical-center-conway",
      "poi_latitude": "35.0563346",
      "poi_longitude": "-92.4191725",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-585-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6dc9-71cb-ae51-fcbf3e9f240d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6dc9-71cb-ae51-fcbf3e9f240d",
        "storage_key": "property/6737460151192627/019e1df5-6dc9-71cb-ae51-fcbf3e9f240d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJrVylAKuD0ocRV9N1Qjd9uxg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_944b636f-bb4b-488c-af6b-2f8831b1db77",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Conway Regional Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "2302 College Ave, Conway, AR 72034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-0f58-7282-a521-31b9e3b97287.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df5-0f58-7282-a521-31b9e3b97287",
        "storage_key": "property/6737460151192627/019e1df5-0f58-7282-a521-31b9e3b97287.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.conwayregional.org/?y_source=1_MTg1ODE3MzItNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1068876465364484161&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "conway-regional-medical-center",
      "poi_latitude": "35.0861252",
      "poi_longitude": "-92.457605",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 501-329-3831",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6dc9-71cb-ae51-fcbf3e9f240d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6dc9-71cb-ae51-fcbf3e9f240d",
        "storage_key": "property/6737460151192627/019e1df5-6dc9-71cb-ae51-fcbf3e9f240d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJJealK-59zYcRQUDTantp1Q4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_e8b29f94-c2b8-4a1c-a1f7-6b5168b36c24",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Baptist Health Urgent Care - Conway North",
      "poi_type": "Health and Wellness",
      "poi_address": "1065 Skyline Dr, Conway, AR 72032, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-2225-737b-9239-0ea82c344a7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-2225-737b-9239-0ea82c344a7f",
        "storage_key": "property/6737460151192627/019e1df7-2225-737b-9239-0ea82c344a7f.webp",
        "width": 750,
        "height": 422
      },
      "poi_business_url": "https://www.urgentteam.com/locations/baptist-health-urgent-care-skyline-dr-conway-ar/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14162503396449788587&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baptist-health-urgent-care---conway-north",
      "poi_latitude": "35.1106329",
      "poi_longitude": "-92.4389577",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 501-499-6222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6fc1-70ac-a1e4-2575b0366bd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6fc1-70ac-a1e4-2575b0366bd8",
        "storage_key": "property/6737460151192627/019e1df5-6fc1-70ac-a1e4-2575b0366bd8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz-Po4oyB0ocRqyKni81Ri8Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_135bb805-d18d-45e3-bd67-55822c6ab64b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Harps Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1120 E German Ln, Conway, AR 72032, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.harpsfood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18446370583201431987&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harps-pharmacy",
      "poi_latitude": "35.0927604",
      "poi_longitude": "-92.4003417",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 501-329-3733",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-42f8-73ed-b68e-41bb07052b94.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-42f8-73ed-b68e-41bb07052b94",
        "storage_key": "property/6737460151192627/019e1df7-42f8-73ed-b68e-41bb07052b94.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN1tGX92D0ocRs8Hv9k-s_v8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_2221ae8c-524c-4164-978e-f42a99ddd204",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Conway Regional Health & Fitness Center",
      "poi_type": "Health and Wellness",
      "poi_address": "700 Salem Rd, Conway, AR 72034, USA",
      "poi_short_description": "Fitness center chain offering a gym, pool, sauna, and steam room, as well as childcare.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-0c37-75fb-b44c-1abb65665601.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df5-0c37-75fb-b44c-1abb65665601",
        "storage_key": "property/6737460151192627/019e1df5-0c37-75fb-b44c-1abb65665601.webp",
        "width": 902,
        "height": 1280
      },
      "poi_business_url": "https://www.conwayregionalhfc.org/?y_source=1_MTg1ODE3NDItNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5416783198821890239&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "conway-regional-health--fitness-center",
      "poi_latitude": "35.0878708",
      "poi_longitude": "-92.4704663",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 501-450-9292",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6fc1-70ac-a1e4-2575b0366bd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6fc1-70ac-a1e4-2575b0366bd8",
        "storage_key": "property/6737460151192627/019e1df5-6fc1-70ac-a1e4-2575b0366bd8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJealK-59zYcRvzgVt55HLEs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_467a7a39-3894-48f8-ae12-82287c7e97d2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "150 E Oak St, Conway, AR 72032, USA",
      "poi_short_description": "Chain gym featuring a range of exercise equipment, plus tanning, and massage options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-0098-75fc-ba5a-ef74118e8345.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df5-0098-75fc-ba5a-ef74118e8345",
        "storage_key": "property/6737460151192627/019e1df5-0098-75fc-ba5a-ef74118e8345.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/conway-ar?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=6705419940064004462&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.0931869",
      "poi_longitude": "-92.4272116",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-358-6261",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6fc1-70ac-a1e4-2575b0366bd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6fc1-70ac-a1e4-2575b0366bd8",
        "storage_key": "property/6737460151192627/019e1df5-6fc1-70ac-a1e4-2575b0366bd8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE9_uby6C0ocRbglWnehvDl0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e4ae31c2-eed1-4b2c-8640-16e32ee238bd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "365 Fitness Conway",
      "poi_type": "Health and Wellness",
      "poi_address": "404 S Harkrider St, Conway, AR 72032, USA",
      "poi_short_description": "Well-established facility featuring clean equipment and friendly staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-256b-72b0-ade3-c796aef55e82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-256b-72b0-ade3-c796aef55e82",
        "storage_key": "property/6737460151192627/019e1df7-256b-72b0-ade3-c796aef55e82.webp",
        "width": 1179,
        "height": 901
      },
      "poi_business_url": "http://www.365fitnessconway.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3785069599143520665&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "365-fitness-conway",
      "poi_latitude": "35.07437350000001",
      "poi_longitude": "-92.4330604",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 501-329-1488",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6fc1-70ac-a1e4-2575b0366bd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6fc1-70ac-a1e4-2575b0366bd8",
        "storage_key": "property/6737460151192627/019e1df5-6fc1-70ac-a1e4-2575b0366bd8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6Sx1pkWC0ocRmWkUC79EhzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_0e3f3121-2318-42a5-9055-ab0c4fa8376a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Crossfit Conway Gym & Fitness Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1195 S Harkrider St, Conway, AR 72032, USA",
      "poi_short_description": "Spacious facility providing fitness classes (including weightlifting), in a welcoming setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-2a02-7284-9766-d193f983907f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-2a02-7284-9766-d193f983907f",
        "storage_key": "property/6737460151192627/019e1df7-2a02-7284-9766-d193f983907f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.crossfitconway.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1357218518157385681&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossfit-conway-gym--fitness-center",
      "poi_latitude": "35.06198699999999",
      "poi_longitude": "-92.427086",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-689-5990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6fc1-70ac-a1e4-2575b0366bd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6fc1-70ac-a1e4-2575b0366bd8",
        "storage_key": "property/6737460151192627/019e1df5-6fc1-70ac-a1e4-2575b0366bd8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkfFxjVaC0ocR0V9aKQ3P1RI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c6193f19-0eb8-49cb-8b15-cae53fdb9b8e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Go Inside Yoga LLC",
      "poi_type": "Health and Wellness",
      "poi_address": "1815 Hairston Ave, Conway, AR 72034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-25c8-718d-8c8f-f805cc9d4e67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-25c8-718d-8c8f-f805cc9d4e67",
        "storage_key": "property/6737460151192627/019e1df7-25c8-718d-8c8f-f805cc9d4e67.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.goinsideyoga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=282281535335088865&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "go-inside-yoga-llc",
      "poi_latitude": "35.0990427",
      "poi_longitude": "-92.4483068",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6eac-744e-8902-b055c15ce740.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6eac-744e-8902-b055c15ce740",
        "storage_key": "property/6737460151192627/019e1df5-6eac-744e-8902-b055c15ce740.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ9WQx-RyC0ocR4cJMkI_d6gM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_b62de1f0-40af-49e0-8a6e-e878862200ff",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Beaverfork Park Lake",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "20 Kinley Dr, Conway, AR 72032, USA",
      "poi_short_description": "Vast lakefront area with swimming, fishing, a boat launch, sports facilities & picnic areas.",
      "poi_long_description": "Vast lakefront area with swimming, fishing, a boat launch, sports facilities & picnic areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-196e-75ef-b1c0-d3b1bead1ad8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df5-196e-75ef-b1c0-d3b1bead1ad8",
        "storage_key": "property/6737460151192627/019e1df5-196e-75ef-b1c0-d3b1bead1ad8.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "https://conwayarkansas.gov/parks/beaverfork/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2654294564082247648&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beaverfork-park-lake",
      "poi_latitude": "35.1395441",
      "poi_longitude": "-92.45403",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 501-450-6117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6d91-759a-835f-260c76e20608.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6d91-759a-835f-260c76e20608",
        "storage_key": "property/6737460151192627/019e1df5-6d91-759a-835f-260c76e20608.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ69aJm9GB0ocR4Gdfzdfy1SQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f4650ff1-4759-4703-9b35-828e31969b3f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Don Owen Sports Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10 Lower Ridge Rd, Conway, AR 72032, USA",
      "poi_short_description": "Indoor sports center featuring a padded walking track plus basketball and volleyball courts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-2ad1-767e-9192-e1681b99c780.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-2ad1-767e-9192-e1681b99c780",
        "storage_key": "property/6737460151192627/019e1df7-2ad1-767e-9192-e1681b99c780.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://conwayarkansas.gov/parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14784276708408320696&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "don-owen-sports-center",
      "poi_latitude": "35.1116667",
      "poi_longitude": "-92.425",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 501-450-6186",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6fc1-70ac-a1e4-2575b0366bd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6fc1-70ac-a1e4-2575b0366bd8",
        "storage_key": "property/6737460151192627/019e1df5-6fc1-70ac-a1e4-2575b0366bd8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE50Zw4SB0ocRuGLC-VVNLM0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_complex"
    },
    {
      "id": "custom_4cca3d66-a836-4061-bb2c-8f92e83ced70",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Tucker Creek Trail: Salem Road Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Tucker Creek Trail, Conway, AR 72034, USA",
      "poi_short_description": "Family and dog-friendly paved path network spanning several miles for biking, hiking and walking.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-2b25-762e-9bb9-be476ce79734.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-2b25-762e-9bb9-be476ce79734",
        "storage_key": "property/6737460151192627/019e1df7-2b25-762e-9bb9-be476ce79734.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://conwayarkansas.gov/parks/park-facilities/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5365978196376962920&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tucker-creek-trail-salem-road-trailhead",
      "poi_latitude": "35.0811606",
      "poi_longitude": "-92.472485",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-450-6186",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6d91-759a-835f-260c76e20608.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6d91-759a-835f-260c76e20608",
        "storage_key": "property/6737460151192627/019e1df5-6d91-759a-835f-260c76e20608.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJAah76fF9zYcRaEeKS73Id0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8881e230-cecc-421e-94cb-dcf144b60877",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Pompe Park Pump Track",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Conway, AR 72034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-2f27-70b6-8b95-bc8e6d76b0f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-2f27-70b6-8b95-bc8e6d76b0f3",
        "storage_key": "property/6737460151192627/019e1df7-2f27-70b6-8b95-bc8e6d76b0f3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://conwayarkansas.gov/parks/park-facilities/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7680379731686203496&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pompe-park-pump-track",
      "poi_latitude": "35.0929949",
      "poi_longitude": "-92.4654353",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 501-450-6186",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6d91-759a-835f-260c76e20608.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6d91-759a-835f-260c76e20608",
        "storage_key": "property/6737460151192627/019e1df5-6d91-759a-835f-260c76e20608.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJaU5ua3p9zYcRaCBEb6wwlmo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_aa59f391-c6a4-47b4-9b95-6e1651343c30",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Laurel Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2310 Robinson Ave, Conway, AR 72034, USA",
      "poi_short_description": "Large, leafy park offering play equipment, picnic tables, open grassy areas & lighted tennis courts.",
      "poi_long_description": "Large, leafy park offering play equipment, picnic tables, open grassy areas & lighted tennis courts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-14d5-77dd-bf1d-6c62d765b966.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df5-14d5-77dd-bf1d-6c62d765b966",
        "storage_key": "property/6737460151192627/019e1df5-14d5-77dd-bf1d-6c62d765b966.webp",
        "width": 1280,
        "height": 1005
      },
      "poi_business_url": "http://conwayparks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10549372850309209659&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "laurel-park",
      "poi_latitude": "35.0890198",
      "poi_longitude": "-92.4571026",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 501-450-6186",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6d91-759a-835f-260c76e20608.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6d91-759a-835f-260c76e20608",
        "storage_key": "property/6737460151192627/019e1df5-6d91-759a-835f-260c76e20608.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJAZzgkAiC0ocRO57U4bbmZpI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_aaef3602-caf3-4458-ac0a-9cc516b0d08d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "5th Ave. Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "573 5th Ave, Conway, AR 72032, USA",
      "poi_short_description": "Spacious park (also clean, according to reviews) boasting a splash pad for kids to cool off in.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-3068-70bd-8b83-850d8355db4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-3068-70bd-8b83-850d8355db4c",
        "storage_key": "property/6737460151192627/019e1df7-3068-70bd-8b83-850d8355db4c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://conwayarkansas.gov/parks/park-facilities/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3518624009383377389&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "5th-ave-park",
      "poi_latitude": "35.08821",
      "poi_longitude": "-92.422373",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 501-450-6186",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6d91-759a-835f-260c76e20608.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6d91-759a-835f-260c76e20608",
        "storage_key": "property/6737460151192627/019e1df5-6d91-759a-835f-260c76e20608.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJoxp_nDOC0ocR7fl04eSp1DA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c652beea-9421-41e7-b4b8-1244b0bd7ada",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Stone Dam Creek Trail: S. German Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1350 S German Ln, Conway, AR 72034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-3170-775f-ab41-3b348df3273e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-3170-775f-ab41-3b348df3273e",
        "storage_key": "property/6737460151192627/019e1df7-3170-775f-ab41-3b348df3273e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://conwayarkansas.gov/parks/park-facilities/",
      "poi_directions_map_url": "https://maps.google.com/?cid=529022225331516703&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stone-dam-creek-trail-s-german-trailhead",
      "poi_latitude": "35.0585901",
      "poi_longitude": "-92.4431038",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6d91-759a-835f-260c76e20608.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6d91-759a-835f-260c76e20608",
        "storage_key": "property/6737460151192627/019e1df5-6d91-759a-835f-260c76e20608.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJOfQvAVaD0ocRH_UrO-l2Vwc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8ef9f9ec-59da-49d8-8dad-af48d2eeb98c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Gatling Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2325 Tyler St, Conway, AR 72034, USA",
      "poi_short_description": "Familiar neighborhood spot with recreational ball fields, picnic facilities & paved walking trails.",
      "poi_long_description": "Familiar neighborhood spot with recreational ball fields, picnic facilities & paved walking trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-1bd8-717e-b6fe-ceb917b3ec15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df5-1bd8-717e-b6fe-ceb917b3ec15",
        "storage_key": "property/6737460151192627/019e1df5-1bd8-717e-b6fe-ceb917b3ec15.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://conwayarkansas.gov/parks/park-facilities/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2112853523570436468&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gatling-park",
      "poi_latitude": "35.10145809999999",
      "poi_longitude": "-92.461085",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 501-450-6186",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6d91-759a-835f-260c76e20608.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6d91-759a-835f-260c76e20608",
        "storage_key": "property/6737460151192627/019e1df5-6d91-759a-835f-260c76e20608.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_xdQvv99zYcRdCnZ1hVdUh0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_05591d2c-2573-405e-b6f2-5128374631ef",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Airport Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "410 E 6th St, Conway, AR 72032, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2873419406500747759&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "airport-park",
      "poi_latitude": "35.085208",
      "poi_longitude": "-92.4242682",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6d91-759a-835f-260c76e20608.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6d91-759a-835f-260c76e20608",
        "storage_key": "property/6737460151192627/019e1df5-6d91-759a-835f-260c76e20608.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQAAbDSC0ocR79kw57lv4Cc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_27c391f6-8e90-4aac-a5a6-b7496ce229b1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Bill and Hillary Clinton National Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Airport Rd, Little Rock, AR 72202, USA",
      "poi_short_description": "Airport in former President Clinton's prior hometown, featuring a host of domestic flights.",
      "poi_long_description": "Airport in former President Clinton's prior hometown, featuring a host of domestic flights.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-31cb-715a-9bc1-97bbd78a2e00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-31cb-715a-9bc1-97bbd78a2e00",
        "storage_key": "property/6737460151192627/019e1df7-31cb-715a-9bc1-97bbd78a2e00.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.clintonairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7788752853462898252&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bill-and-hillary-clinton-national-airport",
      "poi_latitude": "34.7315031",
      "poi_longitude": "-92.2233332",
      "poi_miles_from_property": "36.2",
      "poi_walking_minutes": "13 hours 9 mins",
      "poi_biking_minutes": "3 hours 18 mins",
      "poi_driving_minutes": "36 mins",
      "poi_business_phone": "+1 501-372-3439",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-42f9-702d-8484-e3db4583a56d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-42f9-702d-8484-e3db4583a56d",
        "storage_key": "property/6737460151192627/019e1df7-42f9-702d-8484-e3db4583a56d.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1eIlS2C50ocRTFb3IXQ1F2w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_bf746948-7f36-4267-b744-caba80a67da1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Union Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1400 W Markham St, Little Rock, AR 72201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-3881-7410-a0d5-c0d9f7065025.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-3881-7410-a0d5-c0d9f7065025",
        "storage_key": "property/6737460151192627/019e1df7-3881-7410-a0d5-c0d9f7065025.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=LRK",
      "poi_directions_map_url": "https://maps.google.com/?cid=16485565726769375602&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "union-station",
      "poi_latitude": "34.750483",
      "poi_longitude": "-92.28700990000002",
      "poi_miles_from_property": "32.3",
      "poi_walking_minutes": "11 hours 46 mins",
      "poi_biking_minutes": "2 hours 59 mins",
      "poi_driving_minutes": "35 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-42fb-728a-a702-00107994badb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-42fb-728a-a702-00107994badb",
        "storage_key": "property/6737460151192627/019e1df7-42fb-728a-a702-00107994badb.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ55EYqF-70ocRcmlxKa9-yOQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_ac2dc0a5-19ee-4267-82f6-e7914251079a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Conway Municipal Airport at Cantrell Field",
      "poi_type": "Transportation & Transit",
      "poi_address": "3250 Sand Gap Rd, Conway, AR 72032, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-356a-76f0-aef2-d68d6f42af7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-356a-76f0-aef2-d68d6f42af7c",
        "storage_key": "property/6737460151192627/019e1df7-356a-76f0-aef2-d68d6f42af7c.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://conwayarkansas.gov/airport/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10509252371499621390&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "conway-municipal-airport-at-cantrell-field",
      "poi_latitude": "35.0214346",
      "poi_longitude": "-92.5575292",
      "poi_miles_from_property": "11.5",
      "poi_walking_minutes": "4 hours 12 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 501-358-6200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-42f9-702d-8484-e3db4583a56d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-42f9-702d-8484-e3db4583a56d",
        "storage_key": "property/6737460151192627/019e1df7-42f9-702d-8484-e3db4583a56d.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ86PGRUqC0ocRDpwq-lld2JE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_65220481-7d76-4de5-b9ff-e241e122f2ef",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Best Western Conway",
      "poi_type": "Transportation & Transit",
      "poi_address": "816 E Oak St, Conway, AR 72032, USA",
      "poi_short_description": "Modest property with free WiFi & Southern-style breakfast, plus a buffet restaurant & a pool.",
      "poi_long_description": "Modest property with free WiFi & Southern-style breakfast, plus a buffet restaurant & a pool.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-32ea-738b-8964-b228853db288.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-32ea-738b-8964-b228853db288",
        "storage_key": "property/6737460151192627/019e1df7-32ea-738b-8964-b228853db288.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.bestwestern.com/en_US/book/hotel-rooms.04042.html?iata=00171880&ssob=BLBWI0004G&cid=BLBWI0004G:google:gmb:04042",
      "poi_directions_map_url": "https://maps.google.com/?cid=17201104482975151502&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "best-western-conway",
      "poi_latitude": "35.0921446",
      "poi_longitude": "-92.4200541",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 501-329-9855",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-430b-705d-9ada-ef26f0e8dd5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-430b-705d-9ada-ef26f0e8dd5e",
        "storage_key": "property/6737460151192627/019e1df7-430b-705d-9ada-ef26f0e8dd5e.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJ_94kVs2D0ocRjvUcVGSZtu4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hotel"
    },
    {
      "id": "custom_8b02104a-9aa5-49fd-ae66-4b29e0e7c7dd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Truck Parking Area",
      "poi_type": "Transportation & Transit",
      "poi_address": "I-40, Conway, AR 72032, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-3954-7559-b150-52311e2307a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-3954-7559-b150-52311e2307a5",
        "storage_key": "property/6737460151192627/019e1df7-3954-7559-b150-52311e2307a5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13649599428728482539&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "truck-parking-area",
      "poi_latitude": "34.9961054",
      "poi_longitude": "-92.4131221",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 501-563-6385",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6fc1-70ac-a1e4-2575b0366bd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6fc1-70ac-a1e4-2575b0366bd8",
        "storage_key": "property/6737460151192627/019e1df5-6fc1-70ac-a1e4-2575b0366bd8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuRFF8Nyc0ocR62q8m1webb0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "rest_stop"
    },
    {
      "id": "custom_df088bd3-cb16-43dc-b17c-ac4ef3bab20a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Park & Ride Parking Lot",
      "poi_type": "Transportation & Transit",
      "poi_address": "945 Crain Dr, Conway, AR 72032, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16390690537742268436&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "park--ride-parking-lot",
      "poi_latitude": "35.0673128",
      "poi_longitude": "-92.4148756",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-4329-738a-b4a5-c5c39751afea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df7-4329-738a-b4a5-c5c39751afea",
        "storage_key": "property/6737460151192627/019e1df7-4329-738a-b4a5-c5c39751afea.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJX7m2ja6D0ocRFPh71TNud-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_fae9ad30-6b95-4e65-875d-b2445299d49f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Acxiom LLC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "301 Dave Ward Dr, Conway, AR 72032, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-38eb-751f-be64-e2b9f3eb87cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-38eb-751f-be64-e2b9f3eb87cb",
        "storage_key": "property/6737460151192627/019e1df7-38eb-751f-be64-e2b9f3eb87cb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.acxiom.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13808168637321723765&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "acxiom-llc",
      "poi_latitude": "35.0648403",
      "poi_longitude": "-92.4245798",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 888-322-9466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6fc1-70ac-a1e4-2575b0366bd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6fc1-70ac-a1e4-2575b0366bd8",
        "storage_key": "property/6737460151192627/019e1df5-6fc1-70ac-a1e4-2575b0366bd8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyZkRBVGC0ocRdT9Agjd4oL8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_d6ab31f1-54c9-4600-8724-61fb5961b7fd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Central Baptist College",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1501 College Ave, Conway, AR 72034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.cbc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18230766984718766676&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-baptist-college",
      "poi_latitude": "35.0832302",
      "poi_longitude": "-92.4450092",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 501-329-6872",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6eac-744e-8902-b055c15ce740.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6eac-744e-8902-b055c15ce740",
        "storage_key": "property/6737460151192627/019e1df5-6eac-744e-8902-b055c15ce740.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJYRZAYxSC0ocRVNIUW_uxAP0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_d4457112-1684-4aa7-989f-d39a0e56f676",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Conway Corp",
      "poi_type": "Major Employers & Offices",
      "poi_address": "650 Locust St, Conway, AR 72034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-3c51-76ad-ade4-730907eb5909.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-3c51-76ad-ade4-730907eb5909",
        "storage_key": "property/6737460151192627/019e1df7-3c51-76ad-ade4-730907eb5909.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://www.conwaycorp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13977485903311951866&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "conway-corp",
      "poi_latitude": "35.0873848",
      "poi_longitude": "-92.441572",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-450-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6fc1-70ac-a1e4-2575b0366bd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6fc1-70ac-a1e4-2575b0366bd8",
        "storage_key": "property/6737460151192627/019e1df5-6fc1-70ac-a1e4-2575b0366bd8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR4OKJhaC0ocR-lfwh18B-sE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_bad381c0-58d6-44bd-b82d-69a686cce209",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Faulkner County Courthouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "801 Locust St, Conway, AR 72034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df7-3cd2-77a1-b5b2-fc4375fca14d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df7-3cd2-77a1-b5b2-fc4375fca14d",
        "storage_key": "property/6737460151192627/019e1df7-3cd2-77a1-b5b2-fc4375fca14d.webp",
        "width": 1280,
        "height": 798
      },
      "poi_business_url": "http://www.faulknercounty.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17591115875426098471&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "faulkner-county-courthouse",
      "poi_latitude": "35.0886857",
      "poi_longitude": "-92.4432523",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 501-450-4909",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6dd3-7417-a901-ab3bd06c4492.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6dd3-7417-a901-ab3bd06c4492",
        "storage_key": "property/6737460151192627/019e1df5-6dd3-7417-a901-ab3bd06c4492.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq8BVdReC0ocRJ92B3a8yIPQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_1a91f603-1f11-4272-8141-1890da343bf4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Conway City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1111 Main St, Conway, AR 72032, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-3ca8-77ad-b8c5-3e494e6b507f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df5-3ca8-77ad-b8c5-3e494e6b507f",
        "storage_key": "property/6737460151192627/019e1df5-3ca8-77ad-b8c5-3e494e6b507f.webp",
        "width": 1280,
        "height": 1024
      },
      "poi_business_url": "http://conwayarkansas.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3249458506057028212&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "conway-city-hall",
      "poi_latitude": "35.089281",
      "poi_longitude": "-92.4397891",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-450-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6dd3-7417-a901-ab3bd06c4492.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6dd3-7417-a901-ab3bd06c4492",
        "storage_key": "property/6737460151192627/019e1df5-6dd3-7417-a901-ab3bd06c4492.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvaFi78-D0ocRdJLmfUtlGC0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_07bcfc41-52b3-4871-a094-3d1f98a587ad",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "custom",
      "poi_name": "Conway Public Schools",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2220 Prince St, Conway, AR 72034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.conwayschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15106497951400942858&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "conway-public-schools",
      "poi_latitude": "35.0925492",
      "poi_longitude": "-92.4576441",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-450-4880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df5-6eac-744e-8902-b055c15ce740.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df5-6eac-744e-8902-b055c15ce740",
        "storage_key": "property/6737460151192627/019e1df5-6eac-744e-8902-b055c15ce740.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOaA5FgaC0ocRCl1rYdkPpdE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "custom_274865f3-e1b8-448f-aefe-b77b73bed75d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_d392c22d-b1bc-4965-84e6-7f59fde09a99",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_a809b769-894e-4563-94f1-37b9080f2249",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_e78d255d-0033-4da4-8ed7-e4ec41117fa2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_822e54b9-f612-4440-bf7d-4957f6d42d77",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_2f952fc6-3a28-4126-958b-cb6c8ccce505",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_ee47cb95-815b-48f6-9b15-7ce3c33eb6a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "rating": "5",
      "name": "Brandon",
      "text": "I’ve had a great experience living at Westwood Apartments managed by Trinity Development Company, Inc. This has honestly been one of the best places I’ve lived. The neighborhood is quiet, safe, and very peaceful, which makes it easy to feel comfortable at home. I’ve completed four leases with Trinity, which really speaks to how positive my experience has been over time. They’ve been one of my favorite companies to rent with. The staff is professional, communicative, and genuinely cares about residents. Anytime I’ve had a concern—especially with maintenance—they’ve been quick to respond and get things taken care of without delay. Overall, I highly recommend Westwood Apartments to anyone looking for a reliable management company and a calm, well-maintained place to live!",
      "date": "2026-04-10",
      "title": "false"
    },
    {
      "id": "custom_6d46a322-915d-4c89-8e16-8c15b5025ee4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "rating": "5",
      "name": "Angie Valiant",
      "text": "Very pet friendly",
      "date": "2026-02-20",
      "title": "false"
    },
    {
      "id": "custom_a90fc809-b947-467a-8c03-9b6c42c7b37a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "rating": "5",
      "name": "Simply Cici",
      "text": "I came to do a tour and was greeted with amazing energy from nyasha. She’s very knowledgeable, respectful, and patient. Definitely thinking about leasing a unit just because of her !",
      "date": "2026-01-30",
      "title": "false"
    },
    {
      "id": "custom_931223c7-81f5-43a4-b92f-0444424fb07e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "rating": "5",
      "name": "Mariah",
      "text": "lived here as a child, came back and it’s been 3 years and i still love it. maintenance comes within a day never had any issues, never been bothered within these years. i drop off my money order and you have peace for the whole month. if i call they’re always friendly and helpful",
      "date": "2025-09-12",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_5dff35f7a02425a0201b314b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019e1df4-d4ba-737d-a6d7-3a933a4bcb89.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1df4-d4ba-737d-a6d7-3a933a4bcb89",
        "storage_key": "property/6737460151192627/019e1df4-d4ba-737d-a6d7-3a933a4bcb89.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Entrance",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=66837e8fe5b5fe04c2558098"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a5020-a4a6-7248-b675-518444009e07",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rreaf-woodland-oaks-new",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627"
    },
    {
      "lead_collector_id": "019a5030-f60e-718f-b655-fd506cfe6442",
      "lead_source": "LANDING_PAGE",
      "name": "rreaf-woodland-oaks-lp",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "generator",
      "page_item_url": "apartments-with-pool-conway-ar",
      "search_query": "apartments with pool in Conway AR",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Conway, AR",
      "h2_subtitle": "Discover Woodland Oaks, offering spacious apartments with a pool in Conway, AR. Dive into comfort and modern living with our premium amenities.",
      "page_copy": "Welcome to Woodland Oaks, where comfort meets convenience in the heart of Conway, AR. Our community offers spacious two and three-bedroom apartments with a pool, perfect for relaxation and rejuvenation. Enjoy warm summers by taking a dip in our sparkling pool or simply unwinding on the sun deck.\n\nLocated in the vibrant Downtown Conway, our complex features key amenities including a state-of-the-art fitness center, a clubhouse for leisure, and a pet washing station for your furry companions. It's not just about having a place to stay, but having a home where every day feels like a vacation. With a harmonious blend of luxury and functionality, Woodland Oaks is the ideal choice for those seeking apartments with a pool in Conway, AR.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019d0783-fd22-764b-966e-02e45127b555.webp",
      "featured_image_media": {
        "alt_text": "Community lounge area with comfortable seating, coffee station, and TV.",
        "public_id": "019d0783-fd22-764b-966e-02e45127b555",
        "storage_key": "property/6737460151192627/019d0783-fd22-764b-966e-02e45127b555.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Conway, AR | Woodland Oaks",
      "seo_description": "Explore Woodland Oaks in Conway, AR. Enjoy spacious apartments, a pool, and modern amenities. Perfect home for relaxation and leisure.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "generator",
      "page_item_url": "modern-apartments-fitness-center-conway-ar",
      "search_query": "modern apartments with fitness center conway",
      "category": "Amenity",
      "h1_title": "Modern Apartments with Fitness Center",
      "h2_subtitle": "Discover modern apartments with a fitness center in Conway, AR. Woodland Oaks offers the perfect blend of style and amenities.",
      "page_copy": "Experience the best of modern living at Woodland Oaks, located in the heart of Conway, AR. Our apartments boast contemporary designs paired with a fantastic fitness center for residents looking to maintain an active lifestyle. Whether you're starting your day with an energizing workout or winding down in our modern spaces, we offer convenience and comfort.\n\nIn addition to the state-of-the-art fitness center, Woodland Oaks provides an array of amenities such as a vibrant clubhouse, a tranquil pet play area, and picturesque picnic spots. Choose one of our spacious two or three-bedroom layouts at our modern apartments, where lifestyle and leisure merge seamlessly.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019d0783-fd22-764b-966e-02e45127b555.webp",
      "featured_image_media": {
        "alt_text": "Community lounge area with comfortable seating, coffee station, and TV.",
        "public_id": "019d0783-fd22-764b-966e-02e45127b555",
        "storage_key": "property/6737460151192627/019d0783-fd22-764b-966e-02e45127b555.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Apartments with Fitness Center in Conway",
      "seo_description": "Woodland Oaks offers modern apartments with a fitness center in Conway, AR. Enjoy stylish living with top-notch amenities close by.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-pet-play-area-conway",
      "search_query": "dog friendly apartments with pet play area downtown conway",
      "category": "Amenity",
      "h1_title": "Dog Friendly Apartments in Downtown Conway",
      "h2_subtitle": "Find dog friendly apartments with a pet play area in Downtown Conway. Woodland Oaks welcomes you and your furry friends.",
      "page_copy": "Welcome to Woodland Oaks, the perfect place for pet lovers seeking dog friendly apartments in Downtown Conway. Our community includes a spacious pet play area where your furry companions can frolic and play freely, adding joy to your everyday living.\n\nNestled in the heart of Conway, our modern two and three-bedroom apartments offer not only pet-friendly amenities but also spaces like a clubhouse and serene picnic areas for your enjoyment. Experience the convenience and comfort of Woodland Oaks, where both you and your pets can feel at home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019d0783-fd22-764b-966e-02e45127b555.webp",
      "featured_image_media": {
        "alt_text": "Community lounge area with comfortable seating, coffee station, and TV.",
        "public_id": "019d0783-fd22-764b-966e-02e45127b555",
        "storage_key": "property/6737460151192627/019d0783-fd22-764b-966e-02e45127b555.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Friendly Apartments in Downtown Conway",
      "seo_description": "Explore Woodland Oaks' dog friendly apartments in Downtown Conway. Enjoy a pet play area and other inviting amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "generator",
      "page_item_url": "apartments-with-clubhouse-faulkner-county",
      "search_query": "apartments with clubhouse in faulkner county",
      "category": "Amenity",
      "h1_title": "Apartments with Clubhouse in Faulkner County",
      "h2_subtitle": "Discover apartments with a clubhouse located in Faulkner County. Woodland Oaks provides comfort with unmatched amenities.",
      "page_copy": "At Woodland Oaks, our community in Faulkner County features apartments with a welcoming clubhouse perfect for socializing or relaxing. Located in vibrant Conway, AR, our complex offers a clubhouse where you can host gatherings or meet neighbors in a laid-back setting.\n\nOur spacious two and three-bedroom apartments are complemented by amenities like a sparkling pool, fitness center, and a pet-friendly play area, ensuring a comprehensive living experience. Choose Woodland Oaks for an unbeatable lifestyle in a prime location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019d0783-fd22-764b-966e-02e45127b555.webp",
      "featured_image_media": {
        "alt_text": "Community lounge area with comfortable seating, coffee station, and TV.",
        "public_id": "019d0783-fd22-764b-966e-02e45127b555",
        "storage_key": "property/6737460151192627/019d0783-fd22-764b-966e-02e45127b555.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Clubhouse in Faulkner County, AR",
      "seo_description": "Explore Woodland Oaks for apartments with a clubhouse in Faulkner County. Enjoy top amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-conway-72032",
      "search_query": "air conditioned apartments conway 72032",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Conway 72032",
      "h2_subtitle": "Explore air conditioned apartments in Conway, AR 72032. Woodland Oaks ensures comfort with modern amenities.",
      "page_copy": "Woodland Oaks offers air conditioned apartments in the heart of Conway, AR, within the 72032 zip code. Our complex ensures you stay comfortable year-round with spacious two and three-bedroom units designed to meet modern needs.\n\nLiving at Woodland Oaks means enjoying not just air conditioning but also a range of amenities including a fitness center, pet-friendly play area, and a relaxing clubhouse. Dive into a community that values your comfort and offers a pleasant environment in a prime location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019d0783-fd22-764b-966e-02e45127b555.webp",
      "featured_image_media": {
        "alt_text": "Community lounge area with comfortable seating, coffee station, and TV.",
        "public_id": "019d0783-fd22-764b-966e-02e45127b555",
        "storage_key": "property/6737460151192627/019d0783-fd22-764b-966e-02e45127b555.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in Conway, AR 72032",
      "seo_description": "Find air conditioned apartments at Woodland Oaks in Conway, AR 72032. Enjoy modern living and top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-conway-ar",
      "search_query": "two bedroom apartments conway ar",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Conway, AR",
      "h2_subtitle": "Discover spacious two bedroom apartments in Conway, AR. Woodland Oaks offers comfort and style in every unit.",
      "page_copy": "Find your perfect home in Conway, AR with the two bedroom apartments at Woodland Oaks. Each apartment is designed with ample space and modern amenities, providing residents with a comfortable and stylish living environment. Enjoy ceiling fans, a modern kitchen, and thoughtful layouts that cater to all your living needs.\n\nLocated in the vibrant Downtown Conway area, Woodland Oaks offers not only spacious living areas but also a community rich in amenities like a fitness center, pet play area, and clubhouse. Experience the best of Conway living with convenience and comfort at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019d0783-fd22-764b-966e-02e45127b555.webp",
      "featured_image_media": {
        "alt_text": "Community lounge area with comfortable seating, coffee station, and TV.",
        "public_id": "019d0783-fd22-764b-966e-02e45127b555",
        "storage_key": "property/6737460151192627/019d0783-fd22-764b-966e-02e45127b555.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Conway, AR",
      "seo_description": "Explore two bedroom apartments at Woodland Oaks, Conway, AR. Enjoy spacious living with modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192627",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-faulkner-county",
      "search_query": "three bedroom apartments faulkner county",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Faulkner County",
      "h2_subtitle": "Experience spacious living in three bedroom apartments located in Faulkner County. Woodland Oaks provides style and comfort.",
      "page_copy": "Woodland Oaks in Faulkner County offers spacious three bedroom apartments designed to meet the needs of modern families and individuals seeking room to grow. Each unit boasts comfortable living spaces paired with modern amenities, including ceiling fans and a well-equipped kitchen.\n\nSituated in the lively setting of Downtown Conway, these apartments provide more than just a place to live. With a fitness center, clubhouse, and pet play area, Woodland Oaks ensures a vibrant community life tailored to diverse lifestyle needs, all within Faulkner County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192627/019d0783-fd22-764b-966e-02e45127b555.webp",
      "featured_image_media": {
        "alt_text": "Community lounge area with comfortable seating, coffee station, and TV.",
        "public_id": "019d0783-fd22-764b-966e-02e45127b555",
        "storage_key": "property/6737460151192627/019d0783-fd22-764b-966e-02e45127b555.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Faulkner County",
      "seo_description": "Discover spacious three bedroom apartments at Woodland Oaks in Faulkner County. Enjoy comfort and convenience in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3421"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483384"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4707262"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.woodlandoaksapthome.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.woodlandoaksapthome.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.woodlandoaksapthome.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.woodlandoaksapthome.com?utm_knock=w"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-M83X7WX2"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.woodlandoaksapthome.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.woodlandoaksapthome.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.woodlandoaksapthome.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.woodlandoaksapthome.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.woodlandoaksapthome.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.woodlandoaksapthome.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "501-530-9904"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.woodlandoaksapthome.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.woodlandoaksapthome.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "501-530-9942"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.woodlandoaksapthome.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.woodlandoaksapthome.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.woodlandoaksapthome.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.woodlandoaksapthome.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "501-530-9811"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "501-530-8873"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "501-530-9932"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.woodlandoaksapthome.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "501-530-9588"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "501-530-9715"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "501-510-7608"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "501-530-8786"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "501-799-7631"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.woodlandoaksapthome.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "501-881-3930"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.woodlandoaksapthome.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "501-530-8806"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.woodlandoaksapthome.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "501-214-6028"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "501-443-3473"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.woodlandoaksapthome.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "501-391-3027"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "501-261-6823"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "501-530-9694"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.woodlandoaksapthome.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.woodlandoaksapthome.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "501-506-3865"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321136789"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "501-530-8903"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "501-417-7390"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.woodlandoaksapthome.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "ee90e567de174b11"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.woodlandoaksapthome.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "501-443-2013"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.woodlandoaksapthome.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "501-510-8841"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "501-530-9686"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.woodlandoaksapthome.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "501-799-8680"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "501-530-8838"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "501-530-9032"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "501-530-9877"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.woodlandoaksapthome.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151192627/019e8492-32a3-718d-b82f-1ed89e473a03.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "501-530-9632"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "501-799-7631"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3421",
  "custom_repli_id": "5028483384",
  "custom_realpage_id": "4707262",
  "custom_knock_a_link": "https://www.woodlandoaksapthome.com?utm_knock=a",
  "custom_knock_g_link": "https://www.woodlandoaksapthome.com?utm_knock=g",
  "custom_knock_r_link": "https://www.woodlandoaksapthome.com?utm_knock=r",
  "custom_knock_w_link": "https://www.woodlandoaksapthome.com?utm_knock=w",
  "custom_google_gtm_id": "GTM-M83X7WX2",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.woodlandoaksapthome.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.woodlandoaksapthome.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.woodlandoaksapthome.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.woodlandoaksapthome.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.woodlandoaksapthome.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.woodlandoaksapthome.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_a_number": "501-530-9904",
  "custom_knock_ads_link": "https://www.woodlandoaksapthome.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.woodlandoaksapthome.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "501-530-9942",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.woodlandoaksapthome.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.woodlandoaksapthome.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.woodlandoaksapthome.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.woodlandoaksapthome.com?utm_knock=psa",
  "custom_knock_r_number": "501-530-9811",
  "custom_knock_w_number": "501-530-8873",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "501-530-9932",
  "custom_knock_amap_link": "https://www.woodlandoaksapthome.com?utm_knock=amap",
  "custom_knock_ar_number": "501-530-9588",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "501-530-9715",
  "custom_knock_fb_number": "501-510-7608",
  "custom_knock_fl_number": "501-530-8786",
  "custom_knock_gp_number": "501-799-7631",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.woodlandoaksapthome.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_ads_subscription": "essential",
  "custom_knock_ads_number": "501-881-3930",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.woodlandoaksapthome.com?utm_knock=bcard",
  "custom_knock_bnr_number": "501-530-8806",
  "custom_knock_cfres_link": "https://www.woodlandoaksapthome.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "501-214-6028",
  "custom_knock_lgp_number": "501-443-3473",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.woodlandoaksapthome.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "501-391-3027",
  "custom_knock_psa_number": "501-261-6823",
  "custom_seo_subscription": "essential",
  "custom_knock_amap_number": "501-530-9694",
  "custom_knock_bandit_link": "https://www.woodlandoaksapthome.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.woodlandoaksapthome.com?utm_knock=flyers",
  "custom_knock_osoc_number": "501-506-3865",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17321136789",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "501-530-8903",
  "custom_knock_cfres_number": "501-417-7390",
  "custom_knock_chatgpt_link": "https://www.woodlandoaksapthome.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "ee90e567de174b11",
  "custom_knock_dirmail_link": "https://www.woodlandoaksapthome.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "501-443-2013",
  "custom_knock_propbro_link": "https://www.woodlandoaksapthome.com?utm_knock=propbro",
  "custom_knock_bandit_number": "501-510-8841",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "501-530-9686",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.woodlandoaksapthome.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "501-799-8680",
  "custom_knock_dirmail_number": "501-530-8838",
  "custom_knock_propbro_number": "501-530-9032",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "501-530-9877",
  "custom_knock_maintenance_link": "https://www.woodlandoaksapthome.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151192627/019e8492-32a3-718d-b82f-1ed89e473a03.mp4",
  "custom_knock_maintenance_number": "501-530-9632",
  "custom_ppc_tracking_phone_number": "501-799-7631"
};

export const generatedAt = '2026-10-07T17:13:50.115Z';
